var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllTheDataAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-all-the-data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-all-the-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-all-the-data.animated #freepik--Floor--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Shadows--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Furniture--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Data--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Folder--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Desk--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-all-the-data.animated #freepik--Character--inject-27 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-27",
    className: "animable",
    style: {
      transformOrigin: "250px 346.563px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.39,249.87c-92.5-53.4-242-53.4-333.87,0s-91.41,140,1.09,193.39,242,53.4,333.87,0S508.89,303.28,416.39,249.87Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 346.563px"
    },
    id: "el2pnjqij924c",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-27",
    className: "animable",
    style: {
      transformOrigin: "247.975px 364.461px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ela64fja29654"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,362.24,159.27,335a2.09,2.09,0,0,0,0-3.62l-41.64-24.19a2.08,2.08,0,0,0-2.09,0L67.25,335a2.09,2.09,0,0,0,0,3.62l40.59,23.58A4.16,4.16,0,0,0,112,362.24Z",
    style: {
      opacity: 0.1,
      transformOrigin: "113.26px 334.843px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbt9k18kjne"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.71,388.38,256.89,288.91l-84.24,48.65a2.09,2.09,0,0,0,0,3.62l40.22,23.5c-12.1.12-24.15,2.85-33.4,8.19-19,10.95-19.06,28.69-.23,39.63s49.46,10.94,68.41,0c9.34-5.39,14.09-12.44,14.27-19.5l80.46,46.45a4.18,4.18,0,0,0,4.19,0L428.71,392A2.1,2.1,0,0,0,428.71,388.38Z",
    style: {
      opacity: 0.1,
      transformOrigin: "297.457px 364.461px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-27",
    className: "animable",
    style: {
      transformOrigin: "113.345px 292.375px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150.77 330.37 154.9 332.78 154.89 328 150.77 330.37",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "152.835px 330.39px"
    },
    id: "eler0d30hx1ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.79 304.87 154.79 304.82 154.79 304.82 154.79 304.82 154.79 304.87",
    style: {
      fill: "rgb(120, 120, 120)",
      transformOrigin: "154.79px 304.845px"
    },
    id: "elsyx31y4wkca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.68,
    y: 293.21,
    height: 46.42,
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "134.68px 316.42px"
    },
    id: "ell02uf7ph5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.72 281.61 114.52 304.82 114.52 304.82 154.72 281.61",
    style: {
      fill: "rgb(207, 207, 207)",
      transformOrigin: "134.62px 293.215px"
    },
    id: "elyxhcmhiq1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,328v4.78l4.31-2.49-.16-56.17-48.89,28.23.16,56.17,4.3-2.49v-4.78l36.16-20.88Zm-40.37-23.18h0l40.2-23.21.05,18.22L114.57,323Zm.06,23.21h0l40.21-23.21h0v.05l.05,18.16-40.21,23.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "134.675px 316.32px"
    },
    id: "elqixk7r4a2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4devkf2cmie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.89,328v4.78l4.31-2.49-.16-56.17-48.89,28.23.16,56.17,4.3-2.49v-4.78l36.16-20.88Zm-40.37-23.18h0l40.2-23.21.05,18.22L114.57,323Zm.06,23.21h0l40.21-23.21h0v.05l.05,18.16-40.21,23.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "134.675px 316.32px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "154.84 323.03 154.79 304.87 154.79 304.82 114.58 328.03 114.58 328.03 114.63 346.24 154.84 323.03",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "134.71px 325.53px"
    },
    id: "eltj6hdao7rqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.77 299.83 154.72 281.61 114.52 304.82 114.52 304.82 114.57 323.04 154.77 299.83",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "134.645px 302.325px"
    },
    id: "elk8ub0rapxui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6981pcthq5p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "154.84 323.03 154.79 304.87 154.79 304.82 114.58 328.03 114.58 328.03 114.63 346.24 154.84 323.03",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "134.71px 325.53px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsudzbtb1fkk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "154.77 299.83 154.72 281.61 114.52 304.82 114.52 304.82 114.57 323.04 154.77 299.83",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "134.645px 302.325px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 302.35 67.48 277.54 67.64 333.71 110.32 358.52 110.16 302.35",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "88.9px 318.03px"
    },
    id: "elfgxjlf5j25n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwebppdz532k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 302.35 67.48 277.54 67.64 333.71 110.32 358.52 110.16 302.35",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "88.9px 318.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 302.35 159.05 274.12 116.37 249.32 67.48 277.54 110.16 302.35",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.265px 275.835px"
    },
    id: "el9vhszx38xt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv1htrsk64am"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 302.35 159.05 274.12 116.37 249.32 67.48 277.54 110.16 302.35",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "113.265px 275.835px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9rcjjtxin1o"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.05 274.12 116.37 249.32 67.48 277.54 67.64 333.71 110.32 358.52 114.62 356.03 114.61 351.25 150.77 330.37 154.89 328 154.9 332.78 159.21 330.29 159.05 274.12",
    style: {
      opacity: 0.1,
      transformOrigin: "113.345px 303.92px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el375e89wdeln"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.05 274.12 116.37 249.32 67.48 277.54 67.64 333.71 110.32 358.52 114.62 356.03 114.61 351.25 150.77 330.37 154.89 328 154.9 332.78 159.21 330.29 159.05 274.12",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "113.345px 303.92px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,253.27l13.9.4,13.9-.4c.6,9.39-1.23,19-3.76,23.62h0a6.28,6.28,0,0,1-2.75,2.8,16.29,16.29,0,0,1-14.8,0,6.14,6.14,0,0,1-2.75-2.87C101.09,272.12,99.28,262.61,99.87,253.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "113.771px 267.369px"
    },
    id: "elbtg53giuf3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,247.58c-5.45,3.14-5.48,8.24-.07,11.38s14.21,3.15,19.66,0,5.47-8.24.06-11.38S109.42,244.43,104,247.58Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "113.792px 253.27px"
    },
    id: "elv6ttlesp0tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.13,248.83c-4.25,2.45-4.27,6.43,0,8.88a16.93,16.93,0,0,0,15.34,0c4.25-2.45,4.27-6.43,0-8.88A16.87,16.87,0,0,0,106.13,248.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "113.8px 253.266px"
    },
    id: "eljg1pa55b7as",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3i7rcrx2esv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "113.8px 253.266px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.13,248.83c-4.25,2.45-4.27,6.43,0,8.88a16.93,16.93,0,0,0,15.34,0c4.25-2.45,4.27-6.43,0-8.88A16.87,16.87,0,0,0,106.13,248.83Z",
    id: "eljraaqauje9q",
    className: "animable",
    style: {
      transformOrigin: "113.8px 253.266px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M114.93,253.66a9.18,9.18,0,0,1-8.15,1.86,8.56,8.56,0,0,1-5.71-5.78,16.8,16.8,0,0,0,4.46-3.1,11.54,11.54,0,0,0-6.32.22,6.43,6.43,0,0,1-.47-6,11,11,0,0,1,7.53-.52,10,10,0,0,0-7.62-2.4,29.2,29.2,0,0,1,1.83-11.71c5.18.27,10.21,2.5,11.9,4.11a19,19,0,0,1-.57,5.51,4.46,4.46,0,0,0,2.41-3.56c3.24.81,4.63,2.43,5.13,3.66a13.56,13.56,0,0,1-3.07,6.22c3-.92,4.28-4.31,4.28-4.31C123.56,244.94,123,253,114.93,253.66Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "110.221px 241.016px"
    },
    id: "el4k4gg0sqsgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9eejn2lki8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.93,253.66a9.18,9.18,0,0,1-8.15,1.86,8.56,8.56,0,0,1-5.71-5.78,16.8,16.8,0,0,0,4.46-3.1,11.54,11.54,0,0,0-6.32.22,6.43,6.43,0,0,1-.47-6,11,11,0,0,1,7.53-.52,10,10,0,0,0-7.62-2.4,29.2,29.2,0,0,1,1.83-11.71c5.18.27,10.21,2.5,11.9,4.11a19,19,0,0,1-.57,5.51,4.46,4.46,0,0,0,2.41-3.56c3.24.81,4.63,2.43,5.13,3.66a13.56,13.56,0,0,1-3.07,6.22c3-.92,4.28-4.31,4.28-4.31C123.56,244.94,123,253,114.93,253.66Z",
    style: {
      opacity: 0.2,
      transformOrigin: "110.221px 241.016px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqh3mqyh130k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.93,253.66a9.18,9.18,0,0,1-8.15,1.86,8.56,8.56,0,0,1-5.71-5.78,16.8,16.8,0,0,0,4.46-3.1,11.54,11.54,0,0,0-6.32.22,6.43,6.43,0,0,1-.47-6,11,11,0,0,1,7.53-.52,10,10,0,0,0-7.62-2.4,29.2,29.2,0,0,1,1.83-11.71c5.18.27,10.21,2.5,11.9,4.11a19,19,0,0,1-.57,5.51,4.46,4.46,0,0,0,2.41-3.56c3.24.81,4.63,2.43,5.13,3.66a13.56,13.56,0,0,1-3.07,6.22c3-.92,4.28-4.31,4.28-4.31C123.56,244.94,123,253,114.93,253.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "110.221px 241.016px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,254.43h0a.29.29,0,0,0,.27-.32c-.49-6.55-4.24-17.35-13.16-26.26a.3.3,0,0,0-.43,0,.31.31,0,0,0,0,.42c8.82,8.8,12.51,19.44,13,25.88A.29.29,0,0,0,115.11,254.43Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "108.545px 241.095px"
    },
    id: "elscy7e7vc5ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.67,257.16a8.5,8.5,0,0,0,13.3-3.5,14.05,14.05,0,0,1-4-2.74,11.52,11.52,0,0,1,6,.18,5.58,5.58,0,0,0,.83-5.37,10.85,10.85,0,0,0-7.11-.42,10.44,10.44,0,0,1,7.38-2.19,23.77,23.77,0,0,0-1-10.45c-4.94.3-9.83,2.34-11.52,3.79a15.61,15.61,0,0,0,.2,4.89,3.58,3.58,0,0,1-2-3.14c-3.09.74-4.49,2.19-5,3.29a10.83,10.83,0,0,0,2.5,5.49,6.14,6.14,0,0,1-3.75-3.8C105.14,249.48,105.19,256.56,112.67,257.16Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "117.812px 245.874px"
    },
    id: "el99zatv5ff9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9pbrdpyj6qb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.67,257.16a8.5,8.5,0,0,0,13.3-3.5,14.05,14.05,0,0,1-4-2.74,11.52,11.52,0,0,1,6,.18,5.58,5.58,0,0,0,.83-5.37,10.85,10.85,0,0,0-7.11-.42,10.44,10.44,0,0,1,7.38-2.19,23.77,23.77,0,0,0-1-10.45c-4.94.3-9.83,2.34-11.52,3.79a15.61,15.61,0,0,0,.2,4.89,3.58,3.58,0,0,1-2-3.14c-3.09.74-4.49,2.19-5,3.29a10.83,10.83,0,0,0,2.5,5.49,6.14,6.14,0,0,1-3.75-3.8C105.14,249.48,105.19,256.56,112.67,257.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "117.812px 245.874px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,257.88a.3.3,0,0,0,.29-.26c.85-5.7,5-15.15,13.87-23.06a.3.3,0,0,0-.4-.45c-9,8-13.19,17.63-14.06,23.42a.3.3,0,0,0,.25.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "119.449px 245.957px"
    },
    id: "el5ectq15n0b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Data--inject-27",
    className: "animable",
    style: {
      transformOrigin: "250px 171.13px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 179.86 383.11 181.58 383.31 108.14 380.34 106.42 380.13 179.86",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "381.72px 144px"
    },
    id: "elvojovdla7v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.09 192.75 383.07 194.47 383.09 187.89 380.11 186.17 380.09 192.75",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "381.59px 190.32px"
    },
    id: "el6pxrmnxc914",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.15 184.15 379.12 185.87 379.14 179.29 376.16 177.57 376.15 184.15",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "377.645px 181.72px"
    },
    id: "elaqyq50qerxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.8 197.19 390.77 198.91 390.79 192.34 387.82 190.62 387.8 197.19",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.295px 194.765px"
    },
    id: "elbniv9olxx1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.02 117.98 388 124.55 390.98 126.27 391 119.7 388.02 117.98",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.5px 122.125px"
    },
    id: "eltdh13l3a7pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.01 173.31 386.99 175.02 387.11 133.53 384.13 131.81 384.01 173.31",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "385.56px 153.415px"
    },
    id: "el42gr7sy2oke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.19 168.79 379.17 170.51 379.28 129.02 376.31 127.3 376.19 168.79",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "377.735px 148.905px"
    },
    id: "elis6nutxu83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.94 147.59 390.91 149.31 390.95 135.75 387.98 134.04 387.94 147.59",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.445px 141.675px"
    },
    id: "elswwv752cjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.86 175.53 390.83 177.25 390.89 156.5 387.92 154.78 387.86 175.53",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "389.375px 166.015px"
    },
    id: "elz4m4gml5x2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.16 104.67 260.14 111.25 263.11 112.97 263.13 106.39 260.16 104.67",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.635px 108.82px"
    },
    id: "elbq1esc6f304",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.46 104.51 251.44 106.22 251.46 99.65 248.48 97.93 248.46 104.51",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.96px 102.075px"
    },
    id: "elz1pqjsogkwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.5 91.02 251.47 92.74 251.52 77.52 248.54 75.8 248.5 91.02",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "250.01px 84.27px"
    },
    id: "elalfujd8emfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.1 124.66 263.08 126.38 263.1 119.81 260.12 118.09 260.1 124.66",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.6px 122.235px"
    },
    id: "el4obmk2mf8rq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.31 149.83 255.29 151.54 255.47 86.67 252.5 84.95 252.31 149.83",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "253.89px 118.245px"
    },
    id: "elc9kbamanssb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.16 202.14 255.14 203.86 255.26 160.44 252.29 158.73 252.16 202.14",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "253.71px 181.295px"
    },
    id: "eluihun0j9ov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.16 152.05 259.14 153.77 259.22 124.15 256.24 122.43 256.16 152.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.69px 138.1px"
    },
    id: "el0wptizr31fz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.08 178.51 259.06 180.22 259.12 160.84 256.14 159.12 256.08 178.51",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.6px 169.67px"
    },
    id: "el7jl5uoo320x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.28 169.77 251.25 171.49 251.39 121.78 248.42 120.06 248.28 169.77",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.835px 145.775px"
    },
    id: "elad6kdxggb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.91 190.96 262.89 192.68 262.95 170.51 259.97 168.79 259.91 190.96",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.43px 180.735px"
    },
    id: "elovserdmxjrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.02 153.63 262.99 155.35 263.03 142.6 260.05 140.88 260.02 153.63",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.525px 148.115px"
    },
    id: "el310ojh8gvyx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.29 206.86 426.27 213.44 429.25 215.15 429.27 208.58 426.29 206.86",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.77px 211.005px"
    },
    id: "elm4jvl4h0x1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.29 314.54 417.27 316.26 417.29 309.68 414.31 307.96 414.29 314.54",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.79px 312.11px"
    },
    id: "elidfdfnksdne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.23 227.6 429.21 229.32 429.23 222.75 426.25 221.03 426.23 227.6",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.73px 225.175px"
    },
    id: "elb31vrp7hwnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.31 302.74 421.28 304.46 421.59 195.14 418.62 193.42 418.31 302.74",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "419.95px 248.94px"
    },
    id: "elrvsshnu4cik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.2 289.2 425.17 290.92 425.37 220.53 422.4 218.81 422.2 289.2",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "423.785px 254.865px"
    },
    id: "eln4z50oxs7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.52 235.08 417.49 236.79 417.53 223.59 414.55 221.87 414.52 235.08",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.025px 229.33px"
    },
    id: "elyz4d7pee3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.43 264.79 417.41 266.51 417.47 244.34 414.5 242.62 414.43 264.79",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.95px 254.565px"
    },
    id: "elwwth84ilv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.35 292.42 417.33 294.14 417.39 271.97 414.42 270.25 414.35 292.42",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.87px 282.195px"
    },
    id: "elzv56vynmkhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.07 285.88 429.05 287.6 429.11 265.43 426.13 263.71 426.07 285.88",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.59px 275.655px"
    },
    id: "elf7unwl4lle8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.17 249.36 429.15 251.08 429.19 237.79 426.21 236.08 426.17 249.36",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.68px 243.58px"
    },
    id: "el8nvl0l8vgor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.56 29.45 289.54 36.02 292.52 37.74 292.54 31.17 289.56 29.45",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "291.04px 33.595px"
    },
    id: "el0kz7qbooz0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.7 90.86 280.67 92.58 280.69 86 277.71 84.28 277.7 90.86",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.195px 88.43px"
    },
    id: "ellhwokhmbg4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.65 105.21 280.63 106.93 280.65 100.35 277.67 98.63 277.65 105.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.15px 102.78px"
    },
    id: "elkf6f8pjjsfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.68 86.57 284.66 88.29 284.83 27.72 281.85 26 281.68 86.57",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "283.255px 57.145px"
    },
    id: "el0zzflzrtt89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.6 66.43 288.58 68.15 288.66 39.65 285.68 37.93 285.6 66.43",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "287.13px 53.04px"
    },
    id: "elojuoe9ccuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.51 96.54 288.49 98.26 288.56 75.6 285.58 73.88 285.51 96.54",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "287.035px 86.07px"
    },
    id: "ele939cxc5vzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.84 40.02 280.82 41.74 280.85 28.54 277.88 26.82 277.84 40.02",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.345px 34.28px"
    },
    id: "eln4gai8qh14s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.76 68.51 280.74 70.23 280.77 57.02 277.8 55.31 277.76 68.51",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.265px 62.77px"
    },
    id: "elb3d59xfmopj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.3 119.28 292.28 120.99 292.38 85.8 289.4 84.08 289.3 119.28",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.84px 102.535px"
    },
    id: "elx2qjqhyy60c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.43 76.1 292.4 77.82 292.48 49.48 289.51 47.76 289.43 76.1",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.955px 62.79px"
    },
    id: "elctseeq5ibvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 151.42 266.85 153.88 275.64 158.96 275.6 171.92 259.21 162.46 259.25 150.15 259.25 149.49 259.25 147.65 265.78 151.42",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.425px 159.785px"
    },
    id: "el5py9d4mjqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.405px 170.18px"
    },
    id: "elgv0n3jwxkh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "263.555px 170.995px"
    },
    id: "el1ihjig3y8c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhwgu8lecvd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 170.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eliikebxtau38"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 170.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 113.62 266.85 116.09 275.64 121.16 275.6 134.13 259.21 124.67 259.25 112.36 259.25 111.7 259.25 109.85 265.78 113.62",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.425px 121.99px"
    },
    id: "elhd9fvaoqu1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.405px 132.39px"
    },
    id: "el6jiyfywuipn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "263.555px 133.205px"
    },
    id: "eln70j5jdneri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwjyqs2p7kns"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 132.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzue6yc9hnog"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 133.205px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 75.83 266.85 78.3 275.64 83.37 275.6 96.34 259.21 86.88 259.25 74.57 259.25 73.91 259.25 72.06 265.78 75.83",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.425px 84.2px"
    },
    id: "eli3gcd9k6s7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.405px 94.6px"
    },
    id: "el372q3afq9ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "263.555px 95.415px"
    },
    id: "elo6d0vpq5dz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnad3ogzaax"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 94.6px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1000twci8y19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 95.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 38.04 266.85 40.51 275.64 45.58 275.6 58.55 259.21 49.08 259.25 36.78 259.25 36.12 259.25 34.27 265.78 38.04",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.425px 46.41px"
    },
    id: "el67apwu3iy4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "267.405px 56.81px"
    },
    id: "el4uqyn58y8fl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "263.555px 57.615px"
    },
    id: "elhj7xd0qkjhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnc031vduori"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 56.81px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elac69j3g50u6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 57.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 170.43 299.63 172.89 308.42 177.97 308.38 190.93 292 181.47 292.03 169.16 292.03 168.5 292.04 166.66 298.57 170.43",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.21px 178.795px"
    },
    id: "el5mgnwkmt699",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.19px 189.19px"
    },
    id: "elxw8zzy8pcnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "296.34px 190.005px"
    },
    id: "elqq23r08cjxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltfp4wxfw6ih"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 189.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellrp3cdwels9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 190.005px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 132.63 299.63 135.1 308.42 140.17 308.38 153.14 292 143.68 292.03 131.37 292.03 130.71 292.04 128.86 298.57 132.63",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.21px 141px"
    },
    id: "elx3t4ts2dxih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.19px 151.4px"
    },
    id: "elhr45tpzrq5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "296.34px 152.215px"
    },
    id: "elr92lxe6dx9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elew8fso1dbc5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 151.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elln6olhbig8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 152.215px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 94.84 299.63 97.31 308.42 102.38 308.38 115.35 292 105.88 292.03 93.58 292.03 92.92 292.04 91.07 298.57 94.84",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.21px 103.21px"
    },
    id: "el8qqfm7rlhck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.19px 113.61px"
    },
    id: "el8mn6ebex6a7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "296.34px 114.425px"
    },
    id: "el6mz35f77v6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfjzbmywu72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 113.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldxv6f2uh3n6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 114.425px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 57.05 299.63 59.52 308.42 64.59 308.38 77.56 292 68.09 292.03 55.79 292.03 55.13 292.04 53.28 298.57 57.05",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.21px 65.42px"
    },
    id: "el0wwxx6hdtmrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.19px 75.82px"
    },
    id: "elda1itbvrsij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "296.34px 76.625px"
    },
    id: "eli0ncimiory",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpkl2j2hphkp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 75.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyy36om7pmjs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 76.625px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 189.44 332.42 191.9 341.2 196.98 341.17 209.94 324.78 200.48 324.81 188.17 324.81 187.51 324.82 185.66 331.35 189.44",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.99px 197.8px"
    },
    id: "el3bwb3qfzbdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.975px 208.2px"
    },
    id: "elp6g7gexo84j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.12px 209.015px"
    },
    id: "eluz0ny5entki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrp154ge845"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 208.2px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmvhnv53hsm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 209.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 151.64 332.42 154.11 341.2 159.18 341.17 172.15 324.78 162.69 324.81 150.38 324.81 149.72 324.82 147.87 331.35 151.64",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.99px 160.01px"
    },
    id: "el7xkxpsax924",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.975px 170.41px"
    },
    id: "elj76xclej9ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.12px 171.225px"
    },
    id: "elg5ynf7wjeav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwvze9zbwee9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 170.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8ftifkmxha7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 171.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 113.85 332.42 116.32 341.2 121.39 341.17 134.36 324.78 124.89 324.81 112.59 324.81 111.93 324.82 110.08 331.35 113.85",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.99px 122.22px"
    },
    id: "elkjyhvgxzqnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.975px 132.62px"
    },
    id: "elw9tvxt0e0a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.12px 133.435px"
    },
    id: "elczwbz1za4gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljt2aqx0ig08"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 132.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elydl2n4jisbn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 133.435px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 76.06 332.42 78.53 341.2 83.6 341.17 96.56 324.78 87.1 324.81 74.8 324.81 74.14 324.82 72.29 331.35 76.06",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.99px 84.425px"
    },
    id: "elwa0dgse2dhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.975px 94.83px"
    },
    id: "el31f7js0e6ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.12px 95.64px"
    },
    id: "elvnolbjcmt7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluil39pj0vjh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 94.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh1ptjeaehr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 95.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 208.45 365.2 210.91 373.99 215.99 373.95 228.95 357.56 219.49 357.6 207.18 357.6 206.52 357.6 204.68 364.13 208.45",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.775px 216.815px"
    },
    id: "elozkwcti37po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.755px 227.21px"
    },
    id: "elslkncygv0ij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "361.905px 228.025px"
    },
    id: "elytpjhr40kph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el503qor2x71o"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 227.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkjv6c5wja4m"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 228.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 170.65 365.2 173.12 373.99 178.19 373.95 191.16 357.56 181.7 357.6 169.39 357.6 168.73 357.6 166.88 364.13 170.65",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.775px 179.02px"
    },
    id: "elulgkptomumj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.755px 189.42px"
    },
    id: "elke8rmvnj28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "361.905px 190.235px"
    },
    id: "elfm2lfe9wz2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0jq516807nvo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 189.42px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1o9bd1poiok"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 190.235px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 132.86 365.2 135.33 373.99 140.4 373.95 153.37 357.56 143.9 357.6 131.6 357.6 130.94 357.6 129.09 364.13 132.86",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.775px 141.23px"
    },
    id: "elurd8mvp1tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.755px 151.63px"
    },
    id: "elrkhnkg8bny",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "361.905px 152.445px"
    },
    id: "elj3ee40qaqet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljhhw5lfi5mq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 151.63px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el52o0ubkv05i"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 152.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 95.07 365.2 97.53 373.99 102.61 373.95 115.58 357.56 106.11 357.6 93.81 357.6 93.15 357.6 91.3 364.13 95.07",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.775px 103.44px"
    },
    id: "elphy2t690yh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "365.755px 113.84px"
    },
    id: "elty7tpr77tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "361.905px 114.65px"
    },
    id: "elk36waol6f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7jrscdl4j5m"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 113.84px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elayrn8i03wis"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 114.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 227.46 397.98 229.92 406.77 235 406.74 247.96 390.35 238.5 390.38 226.19 390.38 225.53 390.39 223.69 396.92 227.46",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.56px 235.825px"
    },
    id: "el84lhjqqd7ie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.545px 246.22px"
    },
    id: "elwtth0qyiads",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "394.69px 247.035px"
    },
    id: "el7660jot9pgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk6cjzob3x5i"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 246.22px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely14a1tt48gn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 247.035px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 189.66 397.98 192.13 406.77 197.2 406.74 210.17 390.35 200.71 390.38 188.4 390.38 187.74 390.39 185.89 396.92 189.66",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.56px 198.03px"
    },
    id: "eldc0c2gsbl69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.545px 208.43px"
    },
    id: "el3ij0oyy5y6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "394.69px 209.245px"
    },
    id: "el9aj1zsmcio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6sh4u9m458p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 208.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3shszzqh1vy"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 209.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 151.87 397.98 154.34 406.77 159.41 406.74 172.38 390.35 162.91 390.38 150.61 390.38 149.95 390.39 148.1 396.92 151.87",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.56px 160.24px"
    },
    id: "el197epe74ubu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.545px 170.64px"
    },
    id: "elwcayw2mkqmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "394.69px 171.455px"
    },
    id: "elkymfqxj0ee7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3eo4sj8e362"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 170.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqcfxt3gcus"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 171.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 114.08 397.98 116.54 406.77 121.62 406.74 134.59 390.35 125.12 390.38 112.82 390.38 112.16 390.39 110.31 396.92 114.08",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.56px 122.45px"
    },
    id: "elzmbsvzmsh8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.545px 132.85px"
    },
    id: "elncsxlnqv8bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "394.69px 133.655px"
    },
    id: "el24edjh2btqmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljyu6di8fjz"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 132.85px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7e58kp7hv1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 133.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 246.47 430.76 248.93 439.56 254 439.52 266.97 423.13 257.51 423.16 245.2 423.17 244.54 423.17 242.69 429.7 246.47",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.345px 254.83px"
    },
    id: "elpwdz3knwip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.325px 265.23px"
    },
    id: "elvzz35sl1arh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "427.47px 266.045px"
    },
    id: "eldn51cx9qty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhgoit6pzuns"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 265.23px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxyer0fdirbh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 266.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 208.67 430.76 211.14 439.56 216.21 439.52 229.18 423.13 219.72 423.16 207.41 423.17 206.75 423.17 204.9 429.7 208.67",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.345px 217.04px"
    },
    id: "el31a626lpnq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.325px 227.44px"
    },
    id: "el0ceaau0r4tpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "427.47px 228.255px"
    },
    id: "elxotelpcqwlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4ka9wg12g2h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 227.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljfcnbdspl1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 228.255px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 170.88 430.76 173.35 439.56 178.42 439.52 191.39 423.13 181.92 423.16 169.62 423.17 168.96 423.17 167.11 429.7 170.88",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.345px 179.25px"
    },
    id: "el122cz6m2oxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.325px 189.65px"
    },
    id: "elaxe4zeh8jxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "427.47px 190.46px"
    },
    id: "elzcvnqqds2di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6rdp9f303p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 189.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfpcjbbdnnvb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 190.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 133.09 430.76 135.55 439.56 140.63 439.52 153.59 423.13 144.13 423.16 131.83 423.17 131.17 423.17 129.32 429.7 133.09",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.345px 141.455px"
    },
    id: "el2m103q46yu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.325px 151.86px"
    },
    id: "elpg95vf9qvme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "427.47px 152.665px"
    },
    id: "el760xa2aqhit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltw1s5mxslq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 151.86px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7yi5kd1ua4c"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 152.665px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp73hlqentmf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "349.385px 152.48px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 151.42 266.85 153.88 275.64 158.96 275.6 171.92 259.21 162.46 259.25 150.15 259.25 149.49 259.25 147.65 265.78 151.42",
    id: "el8ny2iu2855q",
    className: "animable",
    style: {
      transformOrigin: "267.425px 159.785px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    id: "elts66aodv0qe",
    className: "animable",
    style: {
      transformOrigin: "267.405px 170.18px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    id: "el25ai5lg4wvg",
    className: "animable",
    style: {
      transformOrigin: "263.555px 170.995px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltn5fhum8a9e"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    style: {
      opacity: 0.2,
      transformOrigin: "267.405px 170.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln6xxr5kqsrn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    style: {
      opacity: 0.2,
      transformOrigin: "263.555px 170.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 113.62 266.85 116.09 275.64 121.16 275.6 134.13 259.21 124.67 259.25 112.36 259.25 111.7 259.25 109.85 265.78 113.62",
    id: "elo82w45bchrh",
    className: "animable",
    style: {
      transformOrigin: "267.425px 121.99px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    id: "elbjl1xy5xht6",
    className: "animable",
    style: {
      transformOrigin: "267.405px 132.39px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    id: "elzn1uh3jx5h",
    className: "animable",
    style: {
      transformOrigin: "263.555px 133.205px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele8avek6nlfs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    style: {
      opacity: 0.2,
      transformOrigin: "267.405px 132.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvgmig34iy3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    style: {
      opacity: 0.2,
      transformOrigin: "263.555px 133.205px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 75.83 266.85 78.3 275.64 83.37 275.6 96.34 259.21 86.88 259.25 74.57 259.25 73.91 259.25 72.06 265.78 75.83",
    id: "elkz39koxz7c",
    className: "animable",
    style: {
      transformOrigin: "267.425px 84.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    id: "elu9w28wlkb2",
    className: "animable",
    style: {
      transformOrigin: "267.405px 94.6px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    id: "eld6xunphmn14",
    className: "animable",
    style: {
      transformOrigin: "263.555px 95.415px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwchfn7ev9bj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    style: {
      opacity: 0.2,
      transformOrigin: "267.405px 94.6px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljwldb2qylwp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    style: {
      opacity: 0.2,
      transformOrigin: "263.555px 95.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 38.04 266.85 40.51 275.64 45.58 275.6 58.55 259.21 49.08 259.25 36.78 259.25 36.12 259.25 34.27 265.78 38.04",
    id: "ela35mvci21sj",
    className: "animable",
    style: {
      transformOrigin: "267.425px 46.41px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    id: "eltq1ebqi9yp",
    className: "animable",
    style: {
      transformOrigin: "267.405px 56.81px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    id: "elp5yj3gfgnl",
    className: "animable",
    style: {
      transformOrigin: "263.555px 57.615px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0nb0y2oyu2fc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    style: {
      opacity: 0.2,
      transformOrigin: "267.405px 56.81px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp4raiioejv"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    style: {
      opacity: 0.2,
      transformOrigin: "263.555px 57.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 170.43 299.63 172.89 308.42 177.97 308.38 190.93 292 181.47 292.03 169.16 292.03 168.5 292.04 166.66 298.57 170.43",
    id: "el1aco3pq7l22",
    className: "animable",
    style: {
      transformOrigin: "300.21px 178.795px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    id: "elfu5drg0xnnn",
    className: "animable",
    style: {
      transformOrigin: "300.19px 189.19px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    id: "eljzynkzvmph",
    className: "animable",
    style: {
      transformOrigin: "296.34px 190.005px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8kbsfxyfppr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    style: {
      opacity: 0.2,
      transformOrigin: "300.19px 189.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli2p3dqofh0j"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    style: {
      opacity: 0.2,
      transformOrigin: "296.34px 190.005px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 132.63 299.63 135.1 308.42 140.17 308.38 153.14 292 143.68 292.03 131.37 292.03 130.71 292.04 128.86 298.57 132.63",
    id: "ele81wuondow7",
    className: "animable",
    style: {
      transformOrigin: "300.21px 141px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    id: "elzxe106xm7j",
    className: "animable",
    style: {
      transformOrigin: "300.19px 151.4px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    id: "elwsz6yi3vxic",
    className: "animable",
    style: {
      transformOrigin: "296.34px 152.215px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6awxj7rwxbg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    style: {
      opacity: 0.2,
      transformOrigin: "300.19px 151.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzqof0qz7us"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    style: {
      opacity: 0.2,
      transformOrigin: "296.34px 152.215px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 94.84 299.63 97.31 308.42 102.38 308.38 115.35 292 105.88 292.03 93.58 292.03 92.92 292.04 91.07 298.57 94.84",
    id: "el9qqxm7pmueg",
    className: "animable",
    style: {
      transformOrigin: "300.21px 103.21px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    id: "elcyzz08t9wbu",
    className: "animable",
    style: {
      transformOrigin: "300.19px 113.61px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    id: "eljzvnzipo4bs",
    className: "animable",
    style: {
      transformOrigin: "296.34px 114.425px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elekl85dmeoov"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    style: {
      opacity: 0.2,
      transformOrigin: "300.19px 113.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela6t5aw2e2cj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    style: {
      opacity: 0.2,
      transformOrigin: "296.34px 114.425px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 57.05 299.63 59.52 308.42 64.59 308.38 77.56 292 68.09 292.03 55.79 292.03 55.13 292.04 53.28 298.57 57.05",
    id: "el57tcqrr9wuw",
    className: "animable",
    style: {
      transformOrigin: "300.21px 65.42px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    id: "elaet9wm09qbq",
    className: "animable",
    style: {
      transformOrigin: "300.19px 75.82px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    id: "elsyi1zbxaoor",
    className: "animable",
    style: {
      transformOrigin: "296.34px 76.625px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvzzdyq9a0zd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    style: {
      opacity: 0.2,
      transformOrigin: "300.19px 75.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldezv3ih97p8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    style: {
      opacity: 0.2,
      transformOrigin: "296.34px 76.625px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 189.44 332.42 191.9 341.2 196.98 341.17 209.94 324.78 200.48 324.81 188.17 324.81 187.51 324.82 185.66 331.35 189.44",
    id: "elyhh9d3200kr",
    className: "animable",
    style: {
      transformOrigin: "332.99px 197.8px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    id: "elro06kpxi7ae",
    className: "animable",
    style: {
      transformOrigin: "332.975px 208.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    id: "elgn112mx7l6r",
    className: "animable",
    style: {
      transformOrigin: "329.12px 209.015px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el46ymegxwaiw"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    style: {
      opacity: 0.2,
      transformOrigin: "332.975px 208.2px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloa55priow8l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    style: {
      opacity: 0.2,
      transformOrigin: "329.12px 209.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 151.64 332.42 154.11 341.2 159.18 341.17 172.15 324.78 162.69 324.81 150.38 324.81 149.72 324.82 147.87 331.35 151.64",
    id: "elttd0n4lfxr8",
    className: "animable",
    style: {
      transformOrigin: "332.99px 160.01px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    id: "eleza659iasbi",
    className: "animable",
    style: {
      transformOrigin: "332.975px 170.41px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    id: "elemerk5da4gg",
    className: "animable",
    style: {
      transformOrigin: "329.12px 171.225px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhwt9mpadmh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    style: {
      opacity: 0.2,
      transformOrigin: "332.975px 170.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx1dmjcspuw"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    style: {
      opacity: 0.2,
      transformOrigin: "329.12px 171.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 113.85 332.42 116.32 341.2 121.39 341.17 134.36 324.78 124.89 324.81 112.59 324.81 111.93 324.82 110.08 331.35 113.85",
    id: "ely54542noo6s",
    className: "animable",
    style: {
      transformOrigin: "332.99px 122.22px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    id: "eltiahxtowybb",
    className: "animable",
    style: {
      transformOrigin: "332.975px 132.62px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    id: "elue1yemnhsyj",
    className: "animable",
    style: {
      transformOrigin: "329.12px 133.435px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el24ge5udbpbq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    style: {
      opacity: 0.2,
      transformOrigin: "332.975px 132.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc5jk2jednkn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    style: {
      opacity: 0.2,
      transformOrigin: "329.12px 133.435px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 76.06 332.42 78.53 341.2 83.6 341.17 96.56 324.78 87.1 324.81 74.8 324.81 74.14 324.82 72.29 331.35 76.06",
    id: "el4bfsgqsw352",
    className: "animable",
    style: {
      transformOrigin: "332.99px 84.425px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    id: "el3z3xuptldv",
    className: "animable",
    style: {
      transformOrigin: "332.975px 94.83px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    id: "elabsjx3s879l",
    className: "animable",
    style: {
      transformOrigin: "329.12px 95.64px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb2ru4bipnj7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    style: {
      opacity: 0.2,
      transformOrigin: "332.975px 94.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4y08tqrqkzi"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    style: {
      opacity: 0.2,
      transformOrigin: "329.12px 95.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 208.45 365.2 210.91 373.99 215.99 373.95 228.95 357.56 219.49 357.6 207.18 357.6 206.52 357.6 204.68 364.13 208.45",
    id: "el3zb3kebar77",
    className: "animable",
    style: {
      transformOrigin: "365.775px 216.815px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    id: "el1dw7z4l9kfoh",
    className: "animable",
    style: {
      transformOrigin: "365.755px 227.21px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    id: "el1p8fizy4j7z",
    className: "animable",
    style: {
      transformOrigin: "361.905px 228.025px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli8gk9pncbvl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    style: {
      opacity: 0.2,
      transformOrigin: "365.755px 227.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7t9phh0naqt"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    style: {
      opacity: 0.2,
      transformOrigin: "361.905px 228.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 170.65 365.2 173.12 373.99 178.19 373.95 191.16 357.56 181.7 357.6 169.39 357.6 168.73 357.6 166.88 364.13 170.65",
    id: "elkmhi53pdvy",
    className: "animable",
    style: {
      transformOrigin: "365.775px 179.02px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    id: "elh60t5lekc1t",
    className: "animable",
    style: {
      transformOrigin: "365.755px 189.42px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    id: "elr8u5clm2ile",
    className: "animable",
    style: {
      transformOrigin: "361.905px 190.235px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el81wovafjwbu"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    style: {
      opacity: 0.2,
      transformOrigin: "365.755px 189.42px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7ns02nf8j9e"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    style: {
      opacity: 0.2,
      transformOrigin: "361.905px 190.235px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 132.86 365.2 135.33 373.99 140.4 373.95 153.37 357.56 143.9 357.6 131.6 357.6 130.94 357.6 129.09 364.13 132.86",
    id: "el85k7cl0yzjp",
    className: "animable",
    style: {
      transformOrigin: "365.775px 141.23px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    id: "el2smyxeagd11",
    className: "animable",
    style: {
      transformOrigin: "365.755px 151.63px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    id: "el8ke90bj5yds",
    className: "animable",
    style: {
      transformOrigin: "361.905px 152.445px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9t9l9gt96i"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    style: {
      opacity: 0.2,
      transformOrigin: "365.755px 151.63px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln7jy4i6ngff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    style: {
      opacity: 0.2,
      transformOrigin: "361.905px 152.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 95.07 365.2 97.53 373.99 102.61 373.95 115.58 357.56 106.11 357.6 93.81 357.6 93.15 357.6 91.3 364.13 95.07",
    id: "ele9gfmzc9ym",
    className: "animable",
    style: {
      transformOrigin: "365.775px 103.44px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    id: "elia7ysj8j1oc",
    className: "animable",
    style: {
      transformOrigin: "365.755px 113.84px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    id: "elgd03vl3h5f",
    className: "animable",
    style: {
      transformOrigin: "361.905px 114.65px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elain5mcob7ir"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    style: {
      opacity: 0.2,
      transformOrigin: "365.755px 113.84px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9z09gr0m3y"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    style: {
      opacity: 0.2,
      transformOrigin: "361.905px 114.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 227.46 397.98 229.92 406.77 235 406.74 247.96 390.35 238.5 390.38 226.19 390.38 225.53 390.39 223.69 396.92 227.46",
    id: "el7gtvefhngdo",
    className: "animable",
    style: {
      transformOrigin: "398.56px 235.825px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    id: "elp406k6zla6i",
    className: "animable",
    style: {
      transformOrigin: "398.545px 246.22px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    id: "el1fsx8e9d9fk",
    className: "animable",
    style: {
      transformOrigin: "394.69px 247.035px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell882xals8jl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    style: {
      opacity: 0.2,
      transformOrigin: "398.545px 246.22px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elti5zuxhub3k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    style: {
      opacity: 0.2,
      transformOrigin: "394.69px 247.035px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 189.66 397.98 192.13 406.77 197.2 406.74 210.17 390.35 200.71 390.38 188.4 390.38 187.74 390.39 185.89 396.92 189.66",
    id: "el25ydel7snph",
    className: "animable",
    style: {
      transformOrigin: "398.56px 198.03px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    id: "eluupxdj0uvp",
    className: "animable",
    style: {
      transformOrigin: "398.545px 208.43px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    id: "elrfalz394wb",
    className: "animable",
    style: {
      transformOrigin: "394.69px 209.245px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp1wxhjnlnhn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    style: {
      opacity: 0.2,
      transformOrigin: "398.545px 208.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgg4txzczq2j"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    style: {
      opacity: 0.2,
      transformOrigin: "394.69px 209.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 151.87 397.98 154.34 406.77 159.41 406.74 172.38 390.35 162.91 390.38 150.61 390.38 149.95 390.39 148.1 396.92 151.87",
    id: "el3ngk4sixhcb",
    className: "animable",
    style: {
      transformOrigin: "398.56px 160.24px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    id: "elrxx4ikz625r",
    className: "animable",
    style: {
      transformOrigin: "398.545px 170.64px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    id: "ellanoauxx8g",
    className: "animable",
    style: {
      transformOrigin: "394.69px 171.455px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7p48cnhf5ro"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    style: {
      opacity: 0.2,
      transformOrigin: "398.545px 170.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc5h3nvhckaq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    style: {
      opacity: 0.2,
      transformOrigin: "394.69px 171.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 114.08 397.98 116.54 406.77 121.62 406.74 134.59 390.35 125.12 390.38 112.82 390.38 112.16 390.39 110.31 396.92 114.08",
    id: "elf3c3f2iut8",
    className: "animable",
    style: {
      transformOrigin: "398.56px 122.45px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    id: "elk3y3r4oy2kr",
    className: "animable",
    style: {
      transformOrigin: "398.545px 132.85px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    id: "el5aig88w6ssq",
    className: "animable",
    style: {
      transformOrigin: "394.69px 133.655px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv5ywb2pq76"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    style: {
      opacity: 0.2,
      transformOrigin: "398.545px 132.85px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el49r3iw0dx7d"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    style: {
      opacity: 0.2,
      transformOrigin: "394.69px 133.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 246.47 430.76 248.93 439.56 254 439.52 266.97 423.13 257.51 423.16 245.2 423.17 244.54 423.17 242.69 429.7 246.47",
    id: "els06sauuv9kd",
    className: "animable",
    style: {
      transformOrigin: "431.345px 254.83px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    id: "eltgs4s4o2u",
    className: "animable",
    style: {
      transformOrigin: "431.325px 265.23px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    id: "elr914daoxjxb",
    className: "animable",
    style: {
      transformOrigin: "427.47px 266.045px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1u3ng10h5zdj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    style: {
      opacity: 0.2,
      transformOrigin: "431.325px 265.23px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltlfismae2ki"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    style: {
      opacity: 0.2,
      transformOrigin: "427.47px 266.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 208.67 430.76 211.14 439.56 216.21 439.52 229.18 423.13 219.72 423.16 207.41 423.17 206.75 423.17 204.9 429.7 208.67",
    id: "el4g48ss7soxe",
    className: "animable",
    style: {
      transformOrigin: "431.345px 217.04px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    id: "ellw0xjpemsv",
    className: "animable",
    style: {
      transformOrigin: "431.325px 227.44px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    id: "el04c61lzjnuc3",
    className: "animable",
    style: {
      transformOrigin: "427.47px 228.255px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5tvxjbrdofn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    style: {
      opacity: 0.2,
      transformOrigin: "431.325px 227.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elexcv4fr11la"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    style: {
      opacity: 0.2,
      transformOrigin: "427.47px 228.255px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 170.88 430.76 173.35 439.56 178.42 439.52 191.39 423.13 181.92 423.16 169.62 423.17 168.96 423.17 167.11 429.7 170.88",
    id: "elmy6yyju258h",
    className: "animable",
    style: {
      transformOrigin: "431.345px 179.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    id: "elsepx63tqmuq",
    className: "animable",
    style: {
      transformOrigin: "431.325px 189.65px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    id: "el2aziecb5bib",
    className: "animable",
    style: {
      transformOrigin: "427.47px 190.46px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellcv8qij4pmc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    style: {
      opacity: 0.2,
      transformOrigin: "431.325px 189.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely9i44y1dsp9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    style: {
      opacity: 0.2,
      transformOrigin: "427.47px 190.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 133.09 430.76 135.55 439.56 140.63 439.52 153.59 423.13 144.13 423.16 131.83 423.17 131.17 423.17 129.32 429.7 133.09",
    id: "elaibruj4i08i",
    className: "animable",
    style: {
      transformOrigin: "431.345px 141.455px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    id: "elfed5p4hpnx",
    className: "animable",
    style: {
      transformOrigin: "431.325px 151.86px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    id: "el1n49g71t4zq",
    className: "animable",
    style: {
      transformOrigin: "427.47px 152.665px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqtkvl1wrpv"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    style: {
      opacity: 0.2,
      transformOrigin: "431.325px 151.86px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln9b6bzyif6n"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    style: {
      opacity: 0.2,
      transformOrigin: "427.47px 152.665px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "elcjq4coo2mfm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "349.385px 152.48px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 151.42 266.85 153.88 275.64 158.96 275.6 171.92 259.21 162.46 259.25 150.15 259.25 149.49 259.25 147.65 265.78 151.42",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.425px 159.785px"
    },
    id: "ely6q8sxazzrj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.405px 170.18px"
    },
    id: "ell7y9c550n4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.555px 170.995px"
    },
    id: "elxhcd6zme8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgx4ssd7mdk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 166.18 275.6 175.64 275.6 174.19 259.21 164.72 259.21 166.18",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 170.18px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0vxfdsv7ewg8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 167.76 259.21 169.22 267.9 174.23 267.9 172.78 259.21 167.76",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 170.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 113.62 266.85 116.09 275.64 121.16 275.6 134.13 259.21 124.67 259.25 112.36 259.25 111.7 259.25 109.85 265.78 113.62",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.425px 121.99px"
    },
    id: "elbloskyop3su",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.405px 132.39px"
    },
    id: "elf2suvmiv14s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.555px 133.205px"
    },
    id: "elp4k1bosrj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluhfjciyglyg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 128.39 275.6 137.85 275.6 136.4 259.21 126.93 259.21 128.39",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 132.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqppyqrt7ygn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 129.97 259.21 131.42 267.9 136.44 267.9 134.98 259.21 129.97",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 133.205px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 75.83 266.85 78.3 275.64 83.37 275.6 96.34 259.21 86.88 259.25 74.57 259.25 73.91 259.25 72.06 265.78 75.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.425px 84.2px"
    },
    id: "elun4alwehnfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.405px 94.6px"
    },
    id: "elti0zc5d2knq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.555px 95.415px"
    },
    id: "el3qveymbw2r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el493rrifqxis"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 90.6 275.6 100.06 275.6 98.6 259.21 89.14 259.21 90.6",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 94.6px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3ozmf2ls9qk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 92.18 259.21 93.63 267.9 98.65 267.9 97.19 259.21 92.18",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 95.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 38.04 266.85 40.51 275.64 45.58 275.6 58.55 259.21 49.08 259.25 36.78 259.25 36.12 259.25 34.27 265.78 38.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.425px 46.41px"
    },
    id: "el0kill8trn9nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "267.405px 56.81px"
    },
    id: "elgho9vgycwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.555px 57.615px"
    },
    id: "elccb7oxwtziq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzfhw77f0zy"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 52.8 275.6 62.27 275.6 60.81 259.21 51.35 259.21 52.8",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "267.405px 56.81px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el43e1kz7ubl6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.21 54.38 259.21 55.84 267.9 60.85 267.9 59.4 259.21 54.38",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "263.555px 57.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 170.43 299.63 172.89 308.42 177.97 308.38 190.93 292 181.47 292.03 169.16 292.03 168.5 292.04 166.66 298.57 170.43",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.21px 178.795px"
    },
    id: "el3ugiscph3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.19px 189.19px"
    },
    id: "el4pdh7k4gda9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.34px 190.005px"
    },
    id: "el9fwjqppupmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4yb7hs0tsvl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 185.19 308.38 194.65 308.38 193.2 292 183.73 292 185.19",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 189.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfvqncbgkr3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 186.77 292 188.23 300.68 193.24 300.68 191.78 292 186.77",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 190.005px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 132.63 299.63 135.1 308.42 140.17 308.38 153.14 292 143.68 292.03 131.37 292.03 130.71 292.04 128.86 298.57 132.63",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.21px 141px"
    },
    id: "eliwjlxsaizmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.19px 151.4px"
    },
    id: "elx4bwaamqay",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.34px 152.215px"
    },
    id: "ela1n89dg2nq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhw0wjzp3pl7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 147.4 308.38 156.86 308.38 155.41 292 145.94 292 147.4",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 151.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elahymyub3vl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 148.98 292 150.43 300.68 155.45 300.68 153.99 292 148.98",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 152.215px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 94.84 299.63 97.31 308.42 102.38 308.38 115.35 292 105.88 292.03 93.58 292.03 92.92 292.04 91.07 298.57 94.84",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.21px 103.21px"
    },
    id: "elaqknczgz3u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.19px 113.61px"
    },
    id: "el2p83qeuxvlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.34px 114.425px"
    },
    id: "elf0l6fnyvbb6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5yqpk5dh69k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 109.61 308.38 119.07 308.38 117.61 292 108.15 292 109.61",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 113.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo6llrj6fzin"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 111.19 292 112.64 300.68 117.66 300.68 116.2 292 111.19",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 114.425px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 57.05 299.63 59.52 308.42 64.59 308.38 77.56 292 68.09 292.03 55.79 292.03 55.13 292.04 53.28 298.57 57.05",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.21px 65.42px"
    },
    id: "el1gtcie2neqxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.19px 75.82px"
    },
    id: "el9inmuicze5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.34px 76.625px"
    },
    id: "el7cf309a65jn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcxf4jw83lzi"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 71.81 308.38 81.28 308.38 79.82 292 70.36 292 71.81",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "300.19px 75.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4o1ihrjeod6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292 73.39 292 74.85 300.68 79.86 300.68 78.41 292 73.39",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "296.34px 76.625px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 189.44 332.42 191.9 341.2 196.98 341.17 209.94 324.78 200.48 324.81 188.17 324.81 187.51 324.82 185.66 331.35 189.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.99px 197.8px"
    },
    id: "eltq6vnt2gsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.975px 208.2px"
    },
    id: "el2b9bh85mce4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.12px 209.015px"
    },
    id: "el7kf2zu1krjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmgwsycmgmz"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 204.2 341.17 213.66 341.17 212.21 324.78 202.74 324.78 204.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 208.2px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhay3jjl4ld4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 205.78 324.78 207.24 333.46 212.25 333.46 210.79 324.78 205.78",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 209.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 151.64 332.42 154.11 341.2 159.18 341.17 172.15 324.78 162.69 324.81 150.38 324.81 149.72 324.82 147.87 331.35 151.64",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.99px 160.01px"
    },
    id: "el8tuwzro4bij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.975px 170.41px"
    },
    id: "ely7z1ybxmdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.12px 171.225px"
    },
    id: "el4yilj22i4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhmtqvne2h9t"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 166.41 341.17 175.87 341.17 174.41 324.78 164.95 324.78 166.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 170.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elocljqlk99ts"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 167.99 324.78 169.44 333.46 174.46 333.46 173 324.78 167.99",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 171.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 113.85 332.42 116.32 341.2 121.39 341.17 134.36 324.78 124.89 324.81 112.59 324.81 111.93 324.82 110.08 331.35 113.85",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.99px 122.22px"
    },
    id: "eldvj9q37dvld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.975px 132.62px"
    },
    id: "eld5rgtrqq80n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.12px 133.435px"
    },
    id: "elh5hm21nl4dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elct0tuumjptj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 128.62 341.17 138.08 341.17 136.62 324.78 127.16 324.78 128.62",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 132.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellfaa4hne54"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 130.2 324.78 131.65 333.46 136.67 333.46 135.21 324.78 130.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 133.435px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.35 76.06 332.42 78.53 341.2 83.6 341.17 96.56 324.78 87.1 324.81 74.8 324.81 74.14 324.82 72.29 331.35 76.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.99px 84.425px"
    },
    id: "elrq80xoti3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.975px 94.83px"
    },
    id: "elwmym7shgdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.12px 95.64px"
    },
    id: "elafw8jd5q7x5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9m7pun8458a"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 90.82 341.17 100.29 341.17 98.83 324.78 89.37 324.78 90.82",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "332.975px 94.83px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8a5yvmqbh2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.78 92.4 324.78 93.86 333.46 98.88 333.46 97.42 324.78 92.4",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "329.12px 95.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 208.45 365.2 210.91 373.99 215.99 373.95 228.95 357.56 219.49 357.6 207.18 357.6 206.52 357.6 204.68 364.13 208.45",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.775px 216.815px"
    },
    id: "elgk16naib2kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.755px 227.21px"
    },
    id: "el180qsvzwat6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.905px 228.025px"
    },
    id: "elpfngsie63rp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrsuigng00zj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 223.21 373.95 232.67 373.95 231.22 357.56 221.75 357.56 223.21",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 227.21px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgzawd6ixqq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 224.79 357.56 226.25 366.25 231.26 366.25 229.81 357.56 224.79",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 228.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 170.65 365.2 173.12 373.99 178.19 373.95 191.16 357.56 181.7 357.6 169.39 357.6 168.73 357.6 166.88 364.13 170.65",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.775px 179.02px"
    },
    id: "elno7vj1g4mwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.755px 189.42px"
    },
    id: "elmb39rfbfqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.905px 190.235px"
    },
    id: "el1e1st47jecy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcz7m3f11feu"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 185.42 373.95 194.88 373.95 193.43 357.56 183.96 357.56 185.42",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 189.42px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb80se2mkhb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 187 357.56 188.45 366.25 193.47 366.25 192.01 357.56 187",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 190.235px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 132.86 365.2 135.33 373.99 140.4 373.95 153.37 357.56 143.9 357.6 131.6 357.6 130.94 357.6 129.09 364.13 132.86",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.775px 141.23px"
    },
    id: "el8sn2h7jnsz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.755px 151.63px"
    },
    id: "el7o492d906h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.905px 152.445px"
    },
    id: "el6ahohwdp8yp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqbj35od5cfo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 147.63 373.95 157.09 373.95 155.63 357.56 146.17 357.56 147.63",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 151.63px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz08r0q4wxy"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 149.21 357.56 150.66 366.25 155.68 366.25 154.22 357.56 149.21",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 152.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.13 95.07 365.2 97.53 373.99 102.61 373.95 115.58 357.56 106.11 357.6 93.81 357.6 93.15 357.6 91.3 364.13 95.07",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.775px 103.44px"
    },
    id: "elpbzg9mxiuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.755px 113.84px"
    },
    id: "elf5ct6y2z04e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.905px 114.65px"
    },
    id: "el3eh26gqm4ka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkl3wvjgz9wj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 109.83 373.95 119.3 373.95 117.84 357.56 108.38 357.56 109.83",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "365.755px 113.84px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellq5bi0afuw"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 111.41 357.56 112.87 366.25 117.89 366.25 116.43 357.56 111.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "361.905px 114.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 227.46 397.98 229.92 406.77 235 406.74 247.96 390.35 238.5 390.38 226.19 390.38 225.53 390.39 223.69 396.92 227.46",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.56px 235.825px"
    },
    id: "eli4jcxu8slap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.545px 246.22px"
    },
    id: "el0nqpxf0qtls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.69px 247.035px"
    },
    id: "el2j79fgr6ytg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqxofxtknk3m"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 242.22 406.74 251.68 406.74 250.23 390.35 240.76 390.35 242.22",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 246.22px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv81cq7diiik"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 243.8 390.35 245.25 399.03 250.27 399.03 248.81 390.35 243.8",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 247.035px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 189.66 397.98 192.13 406.77 197.2 406.74 210.17 390.35 200.71 390.38 188.4 390.38 187.74 390.39 185.89 396.92 189.66",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.56px 198.03px"
    },
    id: "eljq6sw0boizr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.545px 208.43px"
    },
    id: "elz0ek3ojubwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.69px 209.245px"
    },
    id: "elyvkh7kv0lto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el21a0iva4q1l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 204.43 406.74 213.89 406.74 212.44 390.35 202.97 390.35 204.43",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 208.43px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6a9qptdd1da"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 206.01 390.35 207.46 399.03 212.48 399.03 211.02 390.35 206.01",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 209.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 151.87 397.98 154.34 406.77 159.41 406.74 172.38 390.35 162.91 390.38 150.61 390.38 149.95 390.39 148.1 396.92 151.87",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.56px 160.24px"
    },
    id: "el87poo6ykjjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.545px 170.64px"
    },
    id: "elx12khve0ayo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.69px 171.455px"
    },
    id: "eldzzxg4qhry",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqby42x9mia7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 166.64 406.74 176.1 406.74 174.64 390.35 165.18 390.35 166.64",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 170.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7mqwzr5b09h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 168.22 390.35 169.67 399.03 174.69 399.03 173.23 390.35 168.22",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 171.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 114.08 397.98 116.54 406.77 121.62 406.74 134.59 390.35 125.12 390.38 112.82 390.38 112.16 390.39 110.31 396.92 114.08",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.56px 122.45px"
    },
    id: "elufak35rwhj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.545px 132.85px"
    },
    id: "elex9l1gnp4jp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.69px 133.655px"
    },
    id: "elxffek57ld7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt571w9hwck"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 128.84 406.74 138.31 406.74 136.85 390.35 127.39 390.35 128.84",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "398.545px 132.85px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwk5vjdh5qp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.35 130.42 390.35 131.88 399.03 136.89 399.03 135.44 390.35 130.42",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "394.69px 133.655px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 246.47 430.76 248.93 439.56 254 439.52 266.97 423.13 257.51 423.16 245.2 423.17 244.54 423.17 242.69 429.7 246.47",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.345px 254.83px"
    },
    id: "elzrpnnjqfg6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.325px 265.23px"
    },
    id: "elvvnpk7tlxrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.47px 266.045px"
    },
    id: "elkt4r50mkiwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluj0vlua1tp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 261.23 439.52 270.69 439.52 269.24 423.13 259.77 423.13 261.23",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 265.23px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloavp7u2hk5m"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 262.81 423.13 264.26 431.81 269.28 431.81 267.82 423.13 262.81",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 266.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 208.67 430.76 211.14 439.56 216.21 439.52 229.18 423.13 219.72 423.16 207.41 423.17 206.75 423.17 204.9 429.7 208.67",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.345px 217.04px"
    },
    id: "eluvlazc14mzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.325px 227.44px"
    },
    id: "el4p175bvmjhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.47px 228.255px"
    },
    id: "elejoolxkreks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el27t4ilsf2c"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 223.44 439.52 232.9 439.52 231.44 423.13 221.98 423.13 223.44",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 227.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldle660bs8kr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 225.02 423.13 226.47 431.81 231.49 431.81 230.03 423.13 225.02",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 228.255px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 170.88 430.76 173.35 439.56 178.42 439.52 191.39 423.13 181.92 423.16 169.62 423.17 168.96 423.17 167.11 429.7 170.88",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.345px 179.25px"
    },
    id: "el76qnohzzf8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.325px 189.65px"
    },
    id: "el89n6cuejges",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.47px 190.46px"
    },
    id: "el9wyj8me3tqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbrsnwukpbpc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 185.65 439.52 195.11 439.52 193.65 423.13 184.19 423.13 185.65",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 189.65px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el340s5bgnjsv"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 187.22 423.13 188.68 431.81 193.7 431.81 192.24 423.13 187.22",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 190.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "429.7 133.09 430.76 135.55 439.56 140.63 439.52 153.59 423.13 144.13 423.16 131.83 423.17 131.17 423.17 129.32 429.7 133.09",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.345px 141.455px"
    },
    id: "elm1cnu1cjbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.325px 151.86px"
    },
    id: "elb1ci61eltfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.47px 152.665px"
    },
    id: "elgarctvzxf86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfqs24u9i6oc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 147.85 439.52 157.32 439.52 155.86 423.13 146.4 423.13 147.85",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "431.325px 151.86px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluxd4lci06n"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "423.13 149.43 423.13 150.89 431.81 155.9 431.81 154.45 423.13 149.43",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "427.47px 152.665px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "elri8iy82wyf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "350.095px 136.605px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.87 59.82 249.84 68.8 260.59 75.01 260.61 66.03 249.87 59.82",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "255.225px 67.415px"
    },
    id: "el77fwv8emgty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.12 75.43 285.1 82.8 293.92 87.9 293.94 80.52 285.12 75.43",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "289.52px 81.665px"
    },
    id: "el0sjci6zl6wd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.02 110.21 426.99 120.79 439.65 128.1 439.68 117.52 427.02 110.21",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "433.335px 119.155px"
    },
    id: "el2cphnedz2gf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.7 110.21 439.68 117.42 448.31 122.4 448.33 115.19 439.7 110.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.005px 116.305px"
    },
    id: "elqfgaauwoo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.42 142.19 338.39 150.76 348.64 156.68 348.67 148.11 338.42 142.19",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "343.53px 149.435px"
    },
    id: "elx6pslnoide8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.69 142.19 348.67 148.03 355.66 152.07 355.67 146.23 348.69 142.19",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.17px 147.13px"
    },
    id: "eld47jnhqaiwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.94 61.65 351.92 69.21 360.96 74.43 360.98 66.87 351.94 61.65",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "356.45px 68.04px"
    },
    id: "eltf3u08yzcjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.61 65.48 380.58 76.06 393.24 83.37 393.27 72.79 380.61 65.48",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "386.925px 74.425px"
    },
    id: "el567fbbz7asa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.89 92.32 396.86 102.9 409.52 110.21 409.55 99.63 396.89 92.32",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "403.205px 101.265px"
    },
    id: "elvf41eu1w3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.69 133.43 437.66 144.01 450.32 151.32 450.35 140.74 437.69 133.43",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.005px 142.375px"
    },
    id: "elhniwvbwd4z4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 59.79 310.12 66.25 317.84 70.7 317.86 64.25 310.14 59.79",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "313.99px 65.245px"
    },
    id: "elo5mzkyyb0te",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.81 66.92 347.8 70.44 352.01 72.87 352.02 69.35 347.81 66.92",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "349.91px 69.895px"
    },
    id: "elk1cx3l5g67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.58 92.32 383.57 95.84 387.78 98.27 387.79 94.75 383.58 92.32",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "385.68px 95.295px"
    },
    id: "elfzcenvoc3f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.64 136.44 282.62 147.02 295.28 154.33 295.31 143.75 282.64 136.44",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.965px 145.385px"
    },
    id: "elocml97xs6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.69 168.22 304.66 178.8 317.32 186.1 317.35 175.53 304.69 168.22",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.005px 177.16px"
    },
    id: "el9en0q0k2cgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.97 167.44 288.96 170.96 293.17 173.39 293.18 169.87 288.97 167.44",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "291.07px 170.415px"
    },
    id: "elmvqbbxlamz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.41 154.49 414.38 165.07 427.04 172.38 427.07 161.8 414.41 154.49",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "420.725px 163.435px"
    },
    id: "elllfzwob2re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.69 208.93 437.66 219.51 450.32 226.82 450.35 216.24 437.69 208.93",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "444.005px 217.875px"
    },
    id: "el7urmjewanlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.51 176.27 416.5 179.79 420.71 182.22 420.72 178.71 416.51 176.27",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "418.61px 179.245px"
    },
    id: "el0y51u39k6uza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.6 46.39 305.58 52.84 313.31 57.3 313.33 50.85 305.6 46.39",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.455px 51.845px"
    },
    id: "elff52c5acuer",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "79.45 85.27 79.65 156.25 76.77 157.91 76.57 86.93 79.45 85.27",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.11px 121.59px"
    },
    id: "elgo2gcycgo5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.67 162.36 79.68 168.7 76.81 170.36 76.79 164.02 79.67 162.36",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "78.235px 166.36px"
    },
    id: "elywu4xk3x4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.49 154.04 83.51 160.4 80.63 162.06 80.61 155.7 83.49 154.04",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "82.06px 158.05px"
    },
    id: "elizlemxzcwyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.22 166.66 72.24 173 69.36 174.66 69.34 168.32 72.22 166.66",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.79px 170.66px"
    },
    id: "elm77ilps6r8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.02 96.45 72.04 102.79 69.16 104.45 69.14 98.11 72.02 96.45",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.59px 100.45px"
    },
    id: "elluyv8havbu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.79 109.81 75.91 149.91 73.03 151.57 72.92 111.47 75.79 109.81",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "74.415px 130.69px"
    },
    id: "eljwrs8ftzaug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.35 105.45 83.46 145.55 80.59 147.21 80.47 107.11 83.35 105.45",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "81.965px 126.33px"
    },
    id: "elv4mf7e79sbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.06 111.96 72.1 125.07 69.23 126.73 69.19 113.62 72.06 111.96",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.645px 119.345px"
    },
    id: "elksgdzny1jza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.12 132.01 72.18 152.07 69.3 153.73 69.25 133.68 72.12 132.01",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.715px 142.87px"
    },
    id: "elqgajkzo43wn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.32 137.24 189.34 143.59 186.47 145.25 186.45 138.9 189.32 137.24",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.895px 141.245px"
    },
    id: "elfeixm91gxgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.61 130.73 200.63 137.07 197.75 138.73 197.73 132.39 200.61 130.73",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.18px 134.73px"
    },
    id: "elrvcbmrlneob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.55 109.33 200.59 124.05 197.71 125.71 197.67 110.99 200.55 109.33",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.13px 117.52px"
    },
    id: "el51osopbk42d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.36 150.21 189.38 156.55 186.5 158.21 186.49 151.87 189.36 150.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.935px 154.21px"
    },
    id: "elt70bq0qvmyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.74 118.16 196.92 180.87 194.03 182.54 193.85 119.83 196.74 118.16",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.385px 150.35px"
    },
    id: "elxwgueylso3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.94 189.48 197.06 231.45 194.17 233.12 194.06 191.15 196.94 189.48",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.56px 211.3px"
    },
    id: "elgqwt5emvewp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.11 154.4 193.19 183.02 190.31 184.68 190.23 156.06 193.11 154.4",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "191.71px 169.54px"
    },
    id: "elyzbia5wsg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.21 189.87 193.26 208.6 190.39 210.27 190.33 191.53 193.21 189.87",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "191.795px 200.07px"
    },
    id: "el4z75oapj77u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.67 152.11 200.81 200.17 197.93 201.83 197.79 153.77 200.67 152.11",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.3px 176.97px"
    },
    id: "elob3julgzpvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.5 199.21 189.56 220.64 186.69 222.31 186.63 200.87 189.5 199.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.095px 210.76px"
    },
    id: "eljufux4e83jl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.42 172.24 189.46 184.56 186.58 186.22 186.55 173.9 189.42 172.24",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.005px 179.23px"
    },
    id: "el510izum4bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.25 159.41 139.27 165.75 136.39 167.41 136.38 161.07 139.25 159.41",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.825px 163.41px"
    },
    id: "elhuzz1yay7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.83 257.13 150.85 263.49 147.97 265.15 147.96 258.79 150.83 257.13",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.405px 261.14px"
    },
    id: "el3opj1g11ahg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.29 173.1 139.31 179.46 136.43 181.12 136.41 174.76 139.29 173.1",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.86px 177.11px"
    },
    id: "el3dnsbzbzu2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.67 146.41 146.97 252.09 144.1 253.75 143.8 148.07 146.67 146.41",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "145.385px 200.08px"
    },
    id: "elev7o0pxoblh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.02 170.95 143.21 239 140.32 240.67 140.13 172.62 143.02 170.95",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "141.67px 205.81px"
    },
    id: "el3gfmdchp33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.59 173.91 150.63 186.68 147.76 188.34 147.72 175.57 150.59 173.91",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.175px 181.125px"
    },
    id: "ell9m1aojw9wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.65 193.96 150.71 215.4 147.84 217.06 147.78 195.62 150.65 193.96",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.245px 205.51px"
    },
    id: "ell17hnibqjra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.73 220.68 150.79 242.1 147.91 243.76 147.85 222.34 150.73 220.68",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "149.32px 232.22px"
    },
    id: "elg6vywuvqmbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.41 214.35 139.47 235.79 136.59 237.45 136.53 216.01 139.41 214.35",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "138px 225.9px"
    },
    id: "eluvnkl2bibnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.33 187.64 139.37 200.48 136.49 202.14 136.46 189.3 139.33 187.64",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.915px 194.89px"
    },
    id: "elfuup789zuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.86 48.51 130.88 54.85 128 56.51 127.98 50.17 130.86 48.51",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "129.43px 52.51px"
    },
    id: "eldwroquu58d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.31 101.5 142.33 107.85 139.45 109.51 139.44 103.16 142.31 101.5",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.885px 105.505px"
    },
    id: "elaqejw3unuie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.35 115.37 142.37 121.72 139.49 123.38 139.47 117.03 142.35 115.37",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.92px 119.375px"
    },
    id: "elb3a2ihwo3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.31 45.16 138.47 103.72 135.6 105.38 135.43 46.82 138.31 45.16",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.95px 75.27px"
    },
    id: "elw141igt7dyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.62 56.69 134.69 84.23 131.82 85.89 131.74 58.35 134.62 56.69",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.215px 71.29px"
    },
    id: "ely7do0kwxd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.71 91.44 134.78 113.34 131.9 115 131.84 93.1 134.71 91.44",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.31px 103.22px"
    },
    id: "el302t6o0ionl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.15 45.95 142.19 58.71 139.31 60.37 139.28 47.61 142.15 45.95",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.735px 53.16px"
    },
    id: "elnba7noc8ih7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.23 73.48 142.27 86.25 139.39 87.91 139.35 75.14 142.23 73.48",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.81px 80.695px"
    },
    id: "eled5sile32gf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.01 101.31 131.1 135.32 128.23 136.98 128.13 102.97 131.01 101.31",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "129.615px 119.145px"
    },
    id: "elvfryrt5rd1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.91 66.19 130.99 93.59 128.11 95.25 128.03 67.85 130.91 66.19",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "129.51px 80.72px"
    },
    id: "elbgmmby73ug9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljbbw258o5t"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "139.375px 125.585px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.99 36.74 197.04 53.26 177.28 64.66 177.23 48.15 196.99 36.74",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "187.135px 50.7px"
    },
    id: "el3v6pu3xeolu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.44 85.7 203.47 96.28 190.81 103.59 190.78 93.01 203.44 85.7",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.125px 94.645px"
    },
    id: "elzybjtx5ebud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.96 116.76 70.99 127.34 58.33 134.65 58.3 124.07 70.96 116.76",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "64.645px 125.705px"
    },
    id: "el09edx2kqe5m9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.28 116.76 58.3 123.98 49.67 128.96 49.65 121.75 58.28 116.76",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "53.975px 122.86px"
    },
    id: "elzpwzgkzvid9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.3 73.97 165.33 84.55 152.66 91.86 152.64 81.28 165.3 73.97",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "158.985px 82.915px"
    },
    id: "elyas8xgf3dmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.37 72.04 117.4 82.62 104.74 89.93 104.71 79.35 117.37 72.04",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "111.055px 80.985px"
    },
    id: "elumwib6bivj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.09 98.87 101.12 109.45 88.46 116.76 88.43 106.18 101.09 98.87",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "94.775px 107.815px"
    },
    id: "elzk34i98ykec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.31 144.21 62.34 154.79 49.68 162.1 49.65 151.51 62.31 144.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "55.995px 153.155px"
    },
    id: "elu1x4glz4k4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.55 94.65 224.57 101.1 216.84 105.56 216.82 99.11 224.55 94.65",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "220.695px 100.105px"
    },
    id: "elavd7cltntad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.17 73.48 150.18 77 145.97 79.43 145.96 75.91 150.17 73.48",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "148.07px 76.455px"
    },
    id: "elv5l5wsty607",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.4 98.87 114.41 102.39 110.2 104.82 110.19 101.3 114.4 98.87",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "112.3px 101.845px"
    },
    id: "elehamdtuhz1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.88 147.25 209.91 157.83 197.25 165.14 197.22 154.56 209.88 147.25",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "203.565px 156.195px"
    },
    id: "elu127wl6plmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.6 174.08 193.63 184.66 180.97 191.97 180.94 181.39 193.6 174.08",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "187.285px 183.025px"
    },
    id: "elycttk9dsig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.91 174.08 206.92 177.6 202.7 180.03 202.69 176.51 206.91 174.08",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "204.805px 177.055px"
    },
    id: "elw4qe6mpfw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.12 169.7 85.15 180.28 72.49 187.59 72.46 177.01 85.12 169.7",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "78.805px 178.645px"
    },
    id: "elndt7fwvtea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.84 196.53 68.87 207.12 56.21 214.43 56.18 203.84 68.84 196.53",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "62.525px 205.48px"
    },
    id: "eljfbt6mhqwod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.14 196.53 82.16 200.05 77.94 202.49 77.93 198.97 82.14 196.53",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "80.045px 199.51px"
    },
    id: "elzxzxn0qsf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.08 81.24 229.1 87.7 221.38 92.16 221.36 85.7 229.08 81.24",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "225.23px 86.7px"
    },
    id: "elbsop7elwis4",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-27",
    className: "animable",
    style: {
      transformOrigin: "142.4px 155.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.14,90.21l-2.22-1.28-53.56,30.92a4.15,4.15,0,0,1-.65.3l-.13,0a2.49,2.49,0,0,1-.35.08,3.34,3.34,0,0,1-.2-1.16,2.48,2.48,0,0,0-1-2.27h0l-2.22-1.28v0l-.18-.08-.19-.07-.13,0h-.07l-.21,0h-.36l-.14,0-.31.06-.13,0-.13,0a.94.94,0,0,0-.15.06,3.8,3.8,0,0,0-.5.24L91.75,131.11l0,8.13v2.68L92,219.34l2.21,1.28,87.15-50.31Zm-59.88,26.54h0l.17,0Zm.62-.14h0Zm.6,0h0a.9.9,0,0,1,.21.08A1,1,0,0,0,122.48,116.65Zm3.1,4.93h0Zm.59,0h0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "136.555px 154.775px"
    },
    id: "el14icxy8zfgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els7yudtwqen8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.14,90.21l-53.57,30.93a4.15,4.15,0,0,1-.65.3l-.12,0a3.3,3.3,0,0,1-.57.13h-.06a1.71,1.71,0,0,1-.56,0h0a1.84,1.84,0,0,1-.51-.19h0a1.93,1.93,0,0,1-.84-1.12,3.34,3.34,0,0,1-.2-1.16,2.48,2.48,0,0,0-1-2.27,1.45,1.45,0,0,0-.29-.11,1,1,0,0,0-.22-.08,2.19,2.19,0,0,0-.36,0h-.24a4.08,4.08,0,0,0-.45.1l-.17,0a3.7,3.7,0,0,0-.78.34L94,132.4l0,8.13v2.68l.18,77.41,87.15-50.31Z",
    style: {
      opacity: 0.4,
      transformOrigin: "137.665px 155.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsc79gqo7o8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.99 140.53 93.96 132.4 91.75 131.11 91.77 139.24 91.78 141.92 91.96 219.34 94.17 220.62 93.99 143.21 93.99 140.53",
    style: {
      opacity: 0.1,
      transformOrigin: "92.96px 175.865px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el892ha3kaifx"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.99 140.53 93.96 132.4 91.75 131.11 91.77 139.24 91.78 141.92 91.96 219.34 94.17 220.62 93.99 143.21 93.99 140.53",
    style: {
      opacity: 0.2,
      transformOrigin: "92.96px 175.865px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "100.04 216.01 100.04 143.12 175.31 99.66 175.31 172.55 100.04 216.01",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "137.675px 157.835px"
    },
    id: "elcl94o0e4mge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.42 120.46 149.43 122.69 126.13 136.14 126.13 133.91 149.42 120.46",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.78px 128.3px"
    },
    id: "el5k4mzk11v4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.87 111.71 103.72 162.03 94.17 220.62 96.36 221.89 183.48 171.76 193.05 113.42 190.87 111.71",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "143.61px 166.8px"
    },
    id: "eldws917wq1jn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7ed7ufrw7pr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.72 162.03 94.17 220.62 96.36 221.89 105.9 163.74 103.72 162.03",
    style: {
      opacity: 0.2,
      transformOrigin: "100.035px 191.96px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5dsfyf54737"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 113.42 190.87 111.71 103.72 162.03 105.9 163.74 193.05 113.42",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "148.385px 137.725px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "135.42 141.96 135.43 144.19 106.13 161.1 106.13 158.87 135.42 141.96",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "120.78px 151.53px"
    },
    id: "elcca32jvbwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.49 118.32 169.49 120.54 106.12 157.13 106.11 154.91 169.49 118.32",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.8px 137.725px"
    },
    id: "elzlm4vs28mfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.48 114.34 169.48 116.58 106.11 153.16 106.1 150.93 169.48 114.34",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.79px 133.75px"
    },
    id: "elzqu5vgd5ef",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-27",
    className: "animable",
    style: {
      transformOrigin: "303.35px 313.373px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.59 266.15 181.59 344.03 184.93 342.1 184.93 264.22 181.59 266.15",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "183.26px 304.125px"
    },
    id: "eljpelo4llq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.59 266.15 181.59 344.03 178.26 342.1 178.26 264.22 181.59 266.15",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "179.925px 304.125px"
    },
    id: "elgwpn6hc9wsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 291.3 262.98 246.24 262.98 242.66 184.93 287.72 184.93 291.3",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "223.955px 266.98px"
    },
    id: "el39yn0854ph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 283.93 259.64 240.73 262.98 242.66 184.93 287.72 184.93 283.93",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "223.955px 264.225px"
    },
    id: "el1yclicblq5z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.12 313.1 425.12 390.97 428.45 389.04 428.45 311.17 425.12 313.1",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "426.785px 351.07px"
    },
    id: "elqxqofdhtdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.12 313.1 425.12 390.97 421.78 389.04 421.78 311.17 425.12 313.1",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "423.45px 351.07px"
    },
    id: "elwnrkiqvruqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 343.73 437.98 347.06 436.05 347.06 358.18 343.73 360.11",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "345.395px 398.08px"
    },
    id: "eloe26a53gr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 343.73 437.98 340.39 436.05 340.39 358.18 343.73 360.11",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "342.06px 398.08px"
    },
    id: "elokhjgpi1am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.06 385.25 425.12 340.19 425.12 336.61 347.06 381.67 347.06 385.25",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "386.09px 360.93px"
    },
    id: "elums3c33fqsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.06 377.89 421.78 334.68 425.12 336.61 347.06 381.67 347.06 377.89",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "386.09px 358.175px"
    },
    id: "elpkk8d3etkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzexs4rdx0nq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "384.42px 374.575px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "425.12 313.1 425.12 390.97 428.45 389.04 428.45 311.17 425.12 313.1",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "426.785px 351.07px"
    },
    id: "elz8kng8rhrmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.12 313.1 425.12 390.97 421.78 389.04 421.78 311.17 425.12 313.1",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "423.45px 351.07px"
    },
    id: "el0y7et000c1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 343.73 437.98 347.06 436.05 347.06 358.18 343.73 360.11",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "345.395px 398.08px"
    },
    id: "elfzl5v3pnp1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 343.73 437.98 340.39 436.05 340.39 358.18 343.73 360.11",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.06px 398.08px"
    },
    id: "el37ju6hzj1li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.06 385.25 425.12 340.19 425.12 336.61 347.06 381.67 347.06 385.25",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.09px 360.93px"
    },
    id: "el8lh5uahwyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.06 377.89 421.78 334.68 425.12 336.61 347.06 381.67 347.06 377.89",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.09px 358.175px"
    },
    id: "elxhjlqeaeq7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elude3n8oiwer"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "220.62px 292.38px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.59 266.15 181.59 344.03 184.93 342.1 184.93 264.22 181.59 266.15",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "183.26px 304.125px"
    },
    id: "elynk1cn4fkgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.59 266.15 181.59 344.03 178.26 342.1 178.26 264.22 181.59 266.15",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "179.925px 304.125px"
    },
    id: "eli0wuuz67d1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 291.3 262.98 246.24 262.98 242.66 184.93 287.72 184.93 291.3",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "223.955px 266.98px"
    },
    id: "el3l69i5zncmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.93 283.93 259.64 240.73 262.98 242.66 184.93 287.72 184.93 283.93",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "223.955px 264.225px"
    },
    id: "elpo6aj22ikvi",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 351 178.25 255.39 262.97 206.45 428.45 302.06 343.73 351",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "303.35px 278.725px"
    },
    id: "elelm5v40wkja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 178.25 264.23 178.25 255.39 343.73 351 343.73 360.11",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "260.99px 307.75px"
    },
    id: "elx1gcwm164fo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elflvpw8n2xlp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 351 178.25 255.39 262.97 206.45 428.45 302.06 343.73 351",
    style: {
      opacity: 0.3,
      transformOrigin: "303.35px 278.725px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 350.99 428.45 302.05 428.45 311.17 343.73 360.11 343.73 350.99",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "386.09px 331.08px"
    },
    id: "el7360bs4e4er",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9045zp109ds"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 350.99 428.45 302.05 428.45 311.17 343.73 360.11 343.73 350.99",
    style: {
      opacity: 0.1,
      transformOrigin: "386.09px 331.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgjievr7p8wl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.73 360.11 178.25 264.23 178.25 255.39 343.73 351 343.73 360.11",
    style: {
      opacity: 0.2,
      transformOrigin: "260.99px 307.75px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "380.9 309.14 346.25 329.28 322.16 315.37 356.81 295.24 380.9 309.14",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "351.53px 312.26px"
    },
    id: "elekqfhdufec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.99 300.23 371.09 327.14 338.95 320.71 354.86 293.8 386.99 300.23",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "362.97px 310.47px"
    },
    id: "elnrp4565mw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.93 246.42 268.23 272.03 237.66 267.29 249.37 241.68 279.93 246.42",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "258.795px 256.855px"
    },
    id: "elj6w2y7yga7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.42 251.38 264.95 272.97 239.15 262.33 265.61 240.75 291.42 251.38",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "265.285px 256.86px"
    },
    id: "elm0h6qgrjof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.83 244.17 312.69 260.04 273.1 273.26 257.23 257.39 296.83 244.17",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "284.96px 258.715px"
    },
    id: "elbxlrm5m10li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.28,303,309,312.35a2.08,2.08,0,0,1-2.09,0l-44.48-25.65a1.06,1.06,0,0,1-.53-.91v2.42h0a1,1,0,0,0,.53.9l44.48,25.66a2.08,2.08,0,0,0,2.09,0l16.26-9.35a1,1,0,0,0,.52-.89h0V302.1h0A1,1,0,0,1,325.28,303Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "293.84px 300.421px"
    },
    id: "elo0d4z1a91rq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4jj6vfv3um8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.28,303,309,312.35a2.08,2.08,0,0,1-2.09,0l-44.48-25.65a1.06,1.06,0,0,1-.53-.91v2.42h0a1,1,0,0,0,.53.9l44.48,25.66a2.08,2.08,0,0,0,2.09,0l16.26-9.35a1,1,0,0,0,.52-.89h0V302.1h0A1,1,0,0,1,325.28,303Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "293.84px 300.421px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,285.68v.1a.36.36,0,0,1,0-.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.918px 285.73px"
    },
    id: "elj63fc0jfy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45,286.69l44.48,25.65a2.08,2.08,0,0,0,2.09,0L325.28,303a1,1,0,0,0,.52-.91,1,1,0,0,0-.52-.91l-44.52-25.7a2.08,2.08,0,0,0-2.1,0l-16.21,9.38a1,1,0,0,0-.51.81.36.36,0,0,0,0,.1A1.06,1.06,0,0,0,262.45,286.69Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "293.868px 293.909px"
    },
    id: "elzrkicemecv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhfvhe18vqrd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.45,286.69l44.48,25.65a2.08,2.08,0,0,0,2.09,0L325.28,303a1,1,0,0,0,.52-.91,1,1,0,0,0-.52-.91l-44.52-25.7a2.08,2.08,0,0,0-2.1,0l-16.21,9.38a1,1,0,0,0-.51.81.36.36,0,0,0,0,.1A1.06,1.06,0,0,0,262.45,286.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "293.868px 293.909px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,282.51c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-5.46-3.15a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "277.208px 281.64px"
    },
    id: "elwg0t0ddyoeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,278.86a.19.19,0,0,1,0,.36l-1.8,1a.75.75,0,0,1-.62,0l-2-1.14a.19.19,0,0,1,0-.36l1.81-1a.71.71,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "278.25px 278.968px"
    },
    id: "el948hk8l3rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,280.61c.17.1.18.26,0,.36l-1.8,1a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.8-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "281.29px 280.725px"
    },
    id: "elg7q50k4334g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.66,287.63c.18.1.18.26,0,.36L293.86,289a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "293.453px 287.73px"
    },
    id: "el13bf415veymr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.7,289.39c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "296.488px 289.53px"
    },
    id: "elehvvvc558dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.75,288.2a.19.19,0,0,1,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.14a.19.19,0,0,1,0-.36l1.05-.6a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "298.94px 288.12px"
    },
    id: "el8ksx23vfuuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,286.44a.19.19,0,0,1,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "295.897px 286.36px"
    },
    id: "eleyay3ctjszg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67,284.69a.19.19,0,0,1,0,.36l-1,.6a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1-.6a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "292.857px 284.605px"
    },
    id: "elchk9r0h55oe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,290.24a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.695px 290.33px"
    },
    id: "el6k4rs7oykak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,289.44a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "290.955px 289.58px"
    },
    id: "elfj97p60ueko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,300.49c.18.1.18.26,0,.36l-1.05.6a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1-.61a.75.75,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "320.168px 300.404px"
    },
    id: "eloxnqx8ms8gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,290.81a.18.18,0,0,1,0,.35l-1.8,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.71.71,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "275.874px 290.892px"
    },
    id: "elxnx1qdkj3kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,301.34c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "294.108px 301.48px"
    },
    id: "elw2cphuuvkgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.79,290a.19.19,0,0,1,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "301.977px 289.92px"
    },
    id: "elbllohnw19jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,298.73c.17.1.18.26,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "317.191px 298.65px"
    },
    id: "elo9r37jys3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,286a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "284.955px 286.165px"
    },
    id: "el47de1ii1arm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17,287.71a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "287.955px 287.85px"
    },
    id: "el22jnbcvtre9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,288.53a.2.2,0,0,1,0,.37l-1.8,1.05a.7.7,0,0,1-.63,0l-1.95-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "283.807px 288.68px"
    },
    id: "elsu589d2q3va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,285.54a.19.19,0,0,1,0,.36l-1.8,1.05a.7.7,0,0,1-.63,0l-1.95-1.13c-.18-.1-.18-.26,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.807px 285.705px"
    },
    id: "elqjlrc0fnit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,287.29a.19.19,0,0,1,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "269.787px 287.455px"
    },
    id: "el1i4aejfa0up",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,283.37a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-4.13-2.38a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "273.72px 282.835px"
    },
    id: "el0hfbt9vjcg3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,284.24c.18.1.18.27,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "281.948px 284.33px"
    },
    id: "elb322da9pd98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36,303.09c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "297.148px 303.23px"
    },
    id: "el7m7tq7ae515",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,305.69c.17.1.18.26,0,.36l-.49.28a.68.68,0,0,1-.62,0L298,305.1a.19.19,0,0,1,0-.36l.48-.28a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "299.606px 305.395px"
    },
    id: "elworp12xqqrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.11,303c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.898px 303.14px"
    },
    id: "elt9zpnt2yqcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.37,304.94c.18.1.17.26,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-3.84-2.22c-.18-.1-.18-.26,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.238px 304.56px"
    },
    id: "elr6adzj9vuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.43,306.65a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0L303.68,305c-.18-.1-.18-.26,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "307.552px 305.825px"
    },
    id: "elfv7wn75ez9n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.54,302.15c.18.1.18.26,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36L307,301a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "307.332px 302.28px"
    },
    id: "eltniu3u27i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.17,301.3a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "299.955px 301.39px"
    },
    id: "elfkz95qht3yo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,300.45a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "304.385px 300.59px"
    },
    id: "elx67vhpud8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.22,299.6a.19.19,0,0,1,0,.36L297.41,301a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "297.005px 299.755px"
    },
    id: "elz44upvyujp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.65,298.75a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "301.435px 298.89px"
    },
    id: "elpa01p8h1v1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,291.09a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36L281.9,290a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "282.265px 291.25px"
    },
    id: "eli7tp73tqby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.62,285.88c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "290.408px 286.02px"
    },
    id: "elhwd85erzwzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,289.05c.17.1.18.26,0,.36l-1.8,1a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "272.788px 289.14px"
    },
    id: "elf6lo3lsgemt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.19,307.41a.19.19,0,0,1,0,.36l-.48.28a.7.7,0,0,1-.63,0L301,306.82c-.18-.1-.18-.26,0-.36l.49-.28a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.592px 307.115px"
    },
    id: "eljmr5luygch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.16,309.13c.17.1.18.26,0,.36l-.48.28a.68.68,0,0,1-.62,0l-2.13-1.23a.19.19,0,0,1,0-.36l.48-.28a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.546px 308.835px"
    },
    id: "ellxtq7hhf0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.51,306.64a.19.19,0,0,1,0,.36l-.48.28a.68.68,0,0,1-.62,0l-2.13-1.23a.19.19,0,0,1,0-.36l.48-.28a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "303.895px 306.345px"
    },
    id: "elwrunf5vdmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmzjy0ypyjld"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.72,257.79l4.14-2.39a4.2,4.2,0,0,1,4.2,0l23,13.34,2-1.17,16.65,9.74-1.92,1.11,27.24,15.73a1.4,1.4,0,0,1,0,2.42L359.88,299a4.2,4.2,0,0,1-4.2,0l-27.22-15.75-3.18,1.84a8.39,8.39,0,0,1-8.38,0l-9.79-5.65a1.86,1.86,0,0,1,0-3.23l4.58-2.64-23-13.34A1.39,1.39,0,0,1,288.72,257.79Z",
    style: {
      opacity: 0.1,
      transformOrigin: "326.353px 277.2px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.56,272.58l-15.92-9.21v3.36a2.84,2.84,0,0,1-1.39,2.44l-7,4.23a3.18,3.18,0,0,0-1.52,2.18,3.23,3.23,0,0,0,1.58,3.43l8.65,4.95a8,8,0,0,0,8,0l7.56-4.36a2.86,2.86,0,0,0,1.43-2.47v-3.78Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "321.31px 274.201px"
    },
    id: "el05sl4m7qkw4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltf8jt2s57oh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.56,272.58l-15.92-9.21v3.36a2.84,2.84,0,0,1-1.39,2.44l-7,4.23a3.18,3.18,0,0,0-1.52,2.18,3.23,3.23,0,0,0,1.58,3.43l8.65,4.95a8,8,0,0,0,8,0l7.56-4.36a2.86,2.86,0,0,0,1.43-2.47v-3.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "321.31px 274.201px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpabwxn8n2ge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.27,277.81l8.58,4.91a8.15,8.15,0,0,0,8.11,0l6.37-3.67a2.45,2.45,0,0,0,1.22-2.12v-4.34l1.33.76v3.78a2.86,2.86,0,0,1-1.43,2.47L325.9,284a8,8,0,0,1-8,0L309.27,279a3.23,3.23,0,0,1-1.58-3.43A3.2,3.2,0,0,0,309.27,277.81Z",
    style: {
      opacity: 0.1,
      transformOrigin: "321.255px 278.831px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkwq1vbgldha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.33,279a2.45,2.45,0,0,0,1.22-2.12v-4.34l1.33.76v3.78a2.86,2.86,0,0,1-1.43,2.47l-2.68,1.55v-1.21Z",
    style: {
      opacity: 0.4,
      transformOrigin: "332.825px 276.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5vciqt07ml5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.33,279l-1.55.89h0l-16.62-9.5,2.09-1.26a2.84,2.84,0,0,0,1.39-2.44v-3.36l15.92,9.21v4.34A2.45,2.45,0,0,1,332.33,279Z",
    style: {
      opacity: 0.3,
      transformOrigin: "323.86px 271.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.47,289.85Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "360.47px 289.85px"
    },
    id: "elv2ax4rfvzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,288.27l.12-54.46a5.34,5.34,0,0,0-2.43-4.2l-67.69-39a1.7,1.7,0,0,0-1.71-.18l2.55-1.48h0a1.68,1.68,0,0,1,1.77.15l67.68,39a5.32,5.32,0,0,1,2.43,4.2l-.12,54.46a1.74,1.74,0,0,1-.65,1.52h0l-.14.08-2.51,1.46A1.7,1.7,0,0,0,361.23,288.27Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "326.735px 239.293px"
    },
    id: "elwz4ka4h9hmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elde855zpco1o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.07,189h0a1.68,1.68,0,0,1,1.77.15l67.68,39a5,5,0,0,1,1.86,2.07l-2.6,1.51a5.08,5.08,0,0,0-1.86-2.07l-67.69-39a1.7,1.7,0,0,0-1.71-.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "326.45px 210.273px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el09iducyu1vt7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,232.3l-.12,54.46a1.74,1.74,0,0,1-.65,1.52h0l-.14.08-2.51,1.46a1.7,1.7,0,0,0,.7-1.55l.12-54.46a4.75,4.75,0,0,0-.57-2.13l2.6-1.51A4.75,4.75,0,0,1,364,232.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "362.29px 259.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,190.47h0Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "289.49px 190.47px"
    },
    id: "elnibphqdlup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.67,246.47a5.33,5.33,0,0,0,2.43,4.21l67.68,39a1.74,1.74,0,0,0,1.69.19h0l0,0a1.7,1.7,0,0,0,.7-1.55l.12-54.46a5.34,5.34,0,0,0-2.43-4.2l-67.69-39a1.7,1.7,0,0,0-1.71-.18h0a1.69,1.69,0,0,0-.7,1.55Zm2.4,0,.12-53.1,66.53,38.31a3,3,0,0,1,1.23,2.12l-.12,53.1L292.3,248.6A3.05,3.05,0,0,1,291.07,246.48Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "324.98px 240.167px"
    },
    id: "elthqrh23csc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el55ypoyprydf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.67,246.47a5.33,5.33,0,0,0,2.43,4.21l67.68,39a1.74,1.74,0,0,0,1.69.19h0l0,0a1.7,1.7,0,0,0,.7-1.55l.12-54.46a5.34,5.34,0,0,0-2.43-4.2l-67.69-39a1.7,1.7,0,0,0-1.71-.18h0a1.69,1.69,0,0,0-.7,1.55Zm2.4,0,.12-53.1,66.53,38.31a3,3,0,0,1,1.23,2.12l-.12,53.1L292.3,248.6A3.05,3.05,0,0,1,291.07,246.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "324.98px 240.167px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.19,193.38l1.72,1-.11,51.27a3.08,3.08,0,0,0,1.22,2.12l64.81,37.31v1.84L292.3,248.6a3.05,3.05,0,0,1-1.23-2.12Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "324.95px 240.15px"
    },
    id: "el65kvnwa7zpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elajf5nxmwar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.19,193.38l1.72,1-.11,51.27a3.08,3.08,0,0,0,1.22,2.12l64.81,37.31v1.84L292.3,248.6a3.05,3.05,0,0,1-1.23-2.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "324.95px 240.15px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,245.64l.11-51.27,64.81,37.32a3,3,0,0,1,1.23,2.12l-.12,51.26L294,247.76A3.08,3.08,0,0,1,292.8,245.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "325.875px 239.72px"
    },
    id: "elljbob2cbahb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1oh0d2r9ptb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05,
      transformOrigin: "325.86px 239.72px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "307 202.48 329.81 268.36 322 263.87 299.2 197.99 307 202.48",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.505px 233.175px"
    },
    id: "elywept8cw9rp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.45 213.11 348.26 278.99 343.72 276.37 320.91 210.5 325.45 213.11",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "334.585px 244.745px"
    },
    id: "el5pykmnwfci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.58 224.7 358.88 263.1 358.83 285.07 356.45 283.7 333.64 217.82 345.58 224.7",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.26px 251.445px"
    },
    id: "elkgef9p0hm4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.86 217.88 305.49 254.36 301.25 251.92 292.84 227.62 292.86 217.88",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "299.165px 236.12px"
    },
    id: "elgyhawon68g5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.91 194.37 294.38 195.22 317.19 261.1 314.16 259.35 292.9 197.96 292.91 194.37",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.045px 227.735px"
    },
    id: "elz9f83rg3o9k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,281.18a.19.19,0,0,1,0,.36l-1,.6a.68.68,0,0,1-.62,0L285,281c-.18-.1-.18-.26,0-.36l1.05-.6a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.792px 281.09px"
    },
    id: "el0q6912npbczo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,282.37c.17.1.18.26,0,.36l-1.81,1a.71.71,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "284.326px 282.458px"
    },
    id: "el8zv6jyjkvat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,282.93a.19.19,0,0,1,0,.36l-1,.61a.7.7,0,0,1-.63,0L288,282.77c-.18-.1-.18-.26,0-.36l1.05-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "289.812px 282.85px"
    },
    id: "elzc72r985p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.58,284.12c.18.1.18.26,0,.36l-1.8,1a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36L287,283a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "287.372px 284.24px"
    },
    id: "elo8uxd4tkx9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.51,277.67a.19.19,0,0,1,0,.36l-1.05.6a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.05-.6a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "280.675px 277.585px"
    },
    id: "el4y84eoy17at",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.55,279.42a.19.19,0,0,1,0,.36l-1,.61a.7.7,0,0,1-.63,0l-1.95-1.13c-.18-.1-.18-.26,0-.36l1.05-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "283.757px 279.34px"
    },
    id: "el7uposltx38h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74,291.14c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "299.528px 291.28px"
    },
    id: "elhcj8zjnb58t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.17,291.18a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "293.955px 291.27px"
    },
    id: "elkfzrsnvj0dp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,291.71c.17.1.18.26,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.02px 291.63px"
    },
    id: "eltewmogvy89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,291.94a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "289.645px 292.08px"
    },
    id: "elvbv5yghm8dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43,292.79a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.215px 292.955px"
    },
    id: "elcun9j1sq9ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.79,292.9a.19.19,0,0,1,0,.36L303,294.31a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.585px 293.04px"
    },
    id: "elgl2zk6zk03g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,292.91a.19.19,0,0,1,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "296.957px 293.05px"
    },
    id: "elf9gxttjd6y4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.87,293.46a.19.19,0,0,1,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.059px 293.38px"
    },
    id: "elq439vspr32i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.8,293.64c.18.1.18.26,0,.36L293,295.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "292.592px 293.78px"
    },
    id: "elgsy5spxh4ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.38,294.49a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "288.165px 294.58px"
    },
    id: "el1j525j9pz06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.82,294.65c.18.1.18.26,0,.36L306,296.06a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.603px 294.79px"
    },
    id: "el0hwio21vmk6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.17,294.64c.18.1.18.26,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.81-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "299.962px 294.78px"
    },
    id: "elvqpy4nl862n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.75,295.34c.18.1.17.26,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "295.54px 295.48px"
    },
    id: "elxi2dr0qyp2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.32,296.19c.18.1.18.27,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "291.113px 296.33px"
    },
    id: "elvctw08xwtym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.17,296.37a.2.2,0,0,1,0,.37l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.951px 296.52px"
    },
    id: "elzs6qxwe81ns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,296.41a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.655px 296.55px"
    },
    id: "elx82naluqfbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.7,297a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "298.485px 297.165px"
    },
    id: "el2k1sr2qxjjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.27,297.9a.19.19,0,0,1,0,.36l-1.8,1.05a.7.7,0,0,1-.63,0l-1.95-1.13c-.18-.1-.18-.26,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "294.077px 298.04px"
    },
    id: "eludgikllb9nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18,298.11a.19.19,0,0,1,0,.36l-1.81,1a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "305.965px 298.225px"
    },
    id: "el4k18ybw2rsy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,298.16a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.695px 298.3px"
    },
    id: "eliydlqmll3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.28,299.58c.18.1.18.26,0,.36L291.48,301a.68.68,0,0,1-.62,0l-14.12-8.15c-.18-.1-.18-.26,0-.36l1.8-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.01px 296.22px"
    },
    id: "el3i0ac676t4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.18,299.84a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.965px 299.98px"
    },
    id: "elv2gf4q2o3hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.18,301.57a.19.19,0,0,1,0,.36L312.37,303a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.965px 301.73px"
    },
    id: "el8rr8jnjdnvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,301.67a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-5-2.88a.19.19,0,0,1,0-.36l1.81-1a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "316.285px 300.96px"
    },
    id: "elaa7h9zbppj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.18,303.31a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.81-1.05a.71.71,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "314.965px 303.452px"
    },
    id: "eli84jvdimvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.91,295.22c.17.1.18.26,0,.36l-1,.61a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.101px 295.14px"
    },
    id: "elfoqwu69st2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,297c.17.09.18.26,0,.35l-1,.61a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1-.61a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "314.191px 296.91px"
    },
    id: "elc7m8qv52r5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.07,285.13a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13a.19.19,0,0,1,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "277.855px 285.27px"
    },
    id: "elsnldhz8tyab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,285.94a.19.19,0,0,1,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-5.61-3.24c-.17-.1-.18-.26,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "271.539px 285.025px"
    },
    id: "eluk0kdle5tbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,286.83c.18.1.18.26,0,.36l-1.81,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.17-.1-.18-.26,0-.36l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "280.787px 286.97px"
    },
    id: "elibnsrawv4ts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,287.69a.19.19,0,0,1,0,.36l-1.81,1.05a.71.71,0,0,1-.62,0l-2-1.14a.18.18,0,0,1,0-.35l1.8-1.05a.7.7,0,0,1,.63,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "276.371px 287.828px"
    },
    id: "el86s3d4stlpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.53,289.39c.17.1.18.26,0,.36l-1.8,1.05a.68.68,0,0,1-.62,0l-2-1.13c-.18-.1-.18-.26,0-.36l1.81-1.05a.68.68,0,0,1,.62,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279.318px 289.53px"
    },
    id: "elp24qvo6gpjg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-27",
    className: "animable",
    style: {
      transformOrigin: "224.815px 322.441px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.37,348.06l-7.13,49.67c-.39,1.74-2.7,1-2.7-.22S178.89,346,178.89,346Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.455px 372.379px"
    },
    id: "el2cwsu3z0z3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnucd2nsypzk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.89,346.15l5.48,2-1.17,8a14.32,14.32,0,0,1-4.95-2.63C178.66,348.87,178.89,346.15,178.89,346.15Z",
    style: {
      opacity: 0.3,
      transformOrigin: "181.31px 351.15px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,335l5.84,38.41c.45,2.23-2.14,2.14-2.57,0s-7.24-34.53-7.24-34.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.651px 355.024px"
    },
    id: "elmf6zj0rwkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwd4n2cglivg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.59,343.09l-.87-4.17,4-3.88.74,4.88A12.13,12.13,0,0,1,212.59,343.09Z",
    style: {
      opacity: 0.3,
      transformOrigin: "214.09px 339.065px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.49,266.42c-5.57-2-12.47-.24-14.19,8.46Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "202.395px 270.277px"
    },
    id: "elc0evpe91g4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrkhln4jzu2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.49,266.42c-5.57-2-12.47-.24-14.19,8.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "202.395px 270.277px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,374.32c.61,1.94,2.74,3.05,4.77,3.21a23.86,23.86,0,0,0,6-.77c4.48-.81,7,0,11.44-.12a18.79,18.79,0,0,0,4.36-.47,7.19,7.19,0,0,0,3.73-2.2,4.89,4.89,0,0,0,1.08-2.34,4.61,4.61,0,0,1-1.08,3.65,7.19,7.19,0,0,1-3.73,2.2,18.79,18.79,0,0,1-4.36.47c-4.47.11-7-.69-11.44.12a23.86,23.86,0,0,1-6,.77c-2-.16-4.16-1.27-4.77-3.21a5.09,5.09,0,0,1-.16-2.06A4,4,0,0,0,234.81,374.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.421px 375.235px"
    },
    id: "elm36fcerwze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,370.61c.28-1.36.55-2.71.83-4.07a5.89,5.89,0,0,1,.69-2.07,2,2,0,0,1,1.81-1c2.45-.33,5.9-1.21,7.94.19,3.19,2.2,5.27,3.33,9.15,3.18a37.37,37.37,0,0,1,6.07-.24c2,.24,4.1,1.36,4.7,3.3a3.93,3.93,0,0,1,.11,1.77,4.89,4.89,0,0,1-1.08,2.34,7.19,7.19,0,0,1-3.73,2.2,18.79,18.79,0,0,1-4.36.47c-4.47.11-7-.69-11.44.12a23.86,23.86,0,0,1-6,.77c-2-.16-4.16-1.27-4.77-3.21a4,4,0,0,1-.16-.75A9.88,9.88,0,0,1,234.92,370.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.464px 370.231px"
    },
    id: "elv6jkyhjq7iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.79,359.36l.17,5.3a2.1,2.1,0,0,1-2,2.17,33.92,33.92,0,0,1-5.34-.05,3,3,0,0,1-2.73-2.85l-.21-3.91Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "241.821px 363.136px"
    },
    id: "elf7zg8mmxd4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.89,335c0,7.39.78,25.72.78,25.72C240.93,365,236,361.81,236,361.81c-.65-11.8-6.48-23.08-6.48-34.62,8.94-6.13,11.68-7.6,15.31-11.19C246.88,321.51,246.89,329.67,246.89,335Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "238.595px 339.476px"
    },
    id: "el1f7rer6smth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxpva1yekzd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.89,335c0,7.39.78,25.72.78,25.72C240.93,365,236,361.81,236,361.81c-.65-11.8-6.48-23.08-6.48-34.62,8.94-6.13,11.68-7.6,15.31-11.19C246.88,321.51,246.89,329.67,246.89,335Z",
    style: {
      opacity: 0.5,
      transformOrigin: "238.595px 339.476px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.47,387.76c.67,2.08,2.95,3.27,5.12,3.44s4.32-.44,6.47-.82c4.81-.88,7.48,0,12.27-.13a20.49,20.49,0,0,0,4.69-.51,7.69,7.69,0,0,0,4-2.36,5.12,5.12,0,0,0,1.15-2.51,5,5,0,0,1-1.15,3.92,7.76,7.76,0,0,1-4,2.36,20.49,20.49,0,0,1-4.69.51c-4.79.11-7.46-.75-12.27.12a25.46,25.46,0,0,1-6.47.83c-2.17-.17-4.45-1.36-5.12-3.44a5.54,5.54,0,0,1-.16-2.22A4.64,4.64,0,0,0,252.47,387.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.239px 388.74px"
    },
    id: "eltnphjiq3ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6,383.78c.29-1.46.59-2.92.88-4.37a6.54,6.54,0,0,1,.74-2.22,2.2,2.2,0,0,1,2-1.12c2.63-.35,6.33-1.3,8.52.21,3.42,2.35,5.65,3.57,9.81,3.41,2.17-.08,4.35-.53,6.51-.26s4.41,1.47,5.05,3.55a4.16,4.16,0,0,1,.11,1.89,5.12,5.12,0,0,1-1.15,2.51,7.69,7.69,0,0,1-4,2.36,20.49,20.49,0,0,1-4.69.51c-4.79.11-7.46-.75-12.27.13-2.15.38-4.29,1-6.47.82s-4.45-1.36-5.12-3.44a4.64,4.64,0,0,1-.16-.81A10,10,0,0,1,252.6,383.78Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "269.303px 383.342px"
    },
    id: "el49gkqtrj67g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.33,371.7l.18,5.69a2.25,2.25,0,0,1-2.09,2.33,35.28,35.28,0,0,1-5.73-.06,3.22,3.22,0,0,1-2.93-3l-.23-4.21Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "260.021px 375.754px"
    },
    id: "el1fhotkr47axj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.44,345.54c0,7.93.83,27.59.83,27.59-7.23,4.64-12.52,1.2-12.52,1.2-.69-12.65-6.95-24.76-6.95-37.14,9.59-6.58,12.53-8.15,16.43-12C265.42,331.09,265.44,339.85,265.44,345.54Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "256.535px 350.373px"
    },
    id: "elowxn04rom4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluvc95ik4cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.44,345.54c0,7.93.83,27.59.83,27.59-7.23,4.64-12.52,1.2-12.52,1.2-.69-12.65-6.95-24.76-6.95-37.14,9.59-6.58,12.53-8.15,16.43-12C265.42,331.09,265.44,339.85,265.44,345.54Z",
    style: {
      opacity: 0.4,
      transformOrigin: "256.535px 350.373px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxw0xo0o4e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.8,337.19c3.45-2.37,6-4.08,8.12-5.49a58.06,58.06,0,0,1-5.61,21.3A63.09,63.09,0,0,1,246.8,337.19Z",
    style: {
      opacity: 0.3,
      transformOrigin: "250.86px 342.35px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.29,350.27c-8.19,6.54-20.1,12.7-23.07,11.12-8.7-4.57-13.24-21.31-17-34.14-1-3.5-2.06-6.92-3.28-10.2,2.91-1.69,5.51-3.11,7.32-3.92,7.53-3.36,46.71,17.62,46.4,25.11C255.21,340.45,253.48,343.73,245.29,350.27Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "228.801px 337.204px"
    },
    id: "elx5xo5qxtxtl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7fzicze49al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.29,350.27c-8.19,6.54-20.1,12.7-23.07,11.12-8.7-4.57-13.24-21.31-17-34.14-1-3.5-2.06-6.92-3.28-10.2,2.91-1.69,5.51-3.11,7.32-3.92,7.53-3.36,46.71,17.62,46.4,25.11C255.21,340.45,253.48,343.73,245.29,350.27Z",
    style: {
      opacity: 0.2,
      transformOrigin: "228.801px 337.204px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.72,321.22l23.6-5.15c16.6-5.35,30.6-10.19,38-5a9.6,9.6,0,0,1,3.47,4.93c-3.63,3.59-6.37,5.06-15.31,11.19-20,13.87-37,20.19-46.42,13.14S179.72,321.22,179.72,321.22Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "211.29px 326.043px"
    },
    id: "eleyy5c64fa3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyj5hvv9xzra"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.72,321.22l23.6-5.15c16.6-5.35,30.6-10.19,38-5a9.6,9.6,0,0,1,3.47,4.93c-3.63,3.59-6.37,5.06-15.31,11.19-20,13.87-37,20.19-46.42,13.14S179.72,321.22,179.72,321.22Z",
    style: {
      opacity: 0.5,
      transformOrigin: "211.29px 326.043px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,330.79l25.32-5.52c17.81-5.75,32.84-10.94,40.81-5.38a10.29,10.29,0,0,1,3.73,5.3c-3.9,3.85-6.84,5.42-16.43,12-21.43,14.89-39.65,21.66-49.81,14.1S193.37,330.79,193.37,330.79Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "227.264px 335.96px"
    },
    id: "el1rgho92v1jz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elepps7qnz8xt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.37,330.79l25.32-5.52c17.81-5.75,32.84-10.94,40.81-5.38a10.29,10.29,0,0,1,3.73,5.3c-3.9,3.85-6.84,5.42-16.43,12-21.43,14.89-39.65,21.66-49.81,14.1S193.37,330.79,193.37,330.79Z",
    style: {
      opacity: 0.4,
      transformOrigin: "227.264px 335.96px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,240.91c2.89-1.09,5.71-5.24,2.82-7.06-.8-.6-3.15.1-5,0,1.66-1.5,2.05-3.29,1.22-3.85s-3,1.56-7.08,1.16-17.93-4.88-19.68,5.28a2.67,2.67,0,0,0-4.08-.7l2.89,2c-4.28,6-2.89,13,7.49,26.78A7.63,7.63,0,0,0,224.35,266l4.28-10.56,4.19-5.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.786px 248.556px"
    },
    id: "eli5br5xrpqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.63 249.35 239.42 254.2 236.37 255.33 236.63 249.35",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "237.895px 252.34px"
    },
    id: "elmzwktvu5xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,240.91a45.11,45.11,0,0,1,.8,20.6,7,7,0,0,1-1.28,3.26,5.1,5.1,0,0,1-3.54,1.63,15.2,15.2,0,0,1-4-.38l-2.32,6.63a16.05,16.05,0,0,1-13.5-2.78l2.35-5.31a17.08,17.08,0,0,0,8.36.52c3.31-1.78,4-7.83,3.51-9.42a2.5,2.5,0,0,1-2.59.91,3.46,3.46,0,0,1-2.15-1.71,7.12,7.12,0,0,1-.8-2.68,4.94,4.94,0,0,1,.49-3.33,3.5,3.5,0,0,1,3.75-1.26,5.34,5.34,0,0,1,3.15,2.64,8.73,8.73,0,0,1,.56,1.2.75.75,0,0,0,1.45-.18A10.12,10.12,0,0,0,229,246a3.63,3.63,0,0,0,2.7-1.66,3.41,3.41,0,0,0,.52-3A10,10,0,0,0,235.67,240.91Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "224.563px 257.011px"
    },
    id: "elcasm72jor4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.56,275.92l-24.41-9.06c-6.62-2.18-12.29.78-17.09,10.28s-10.41,26.51-7.28,51.09c1.44,11,34.79,15.23,42.11-.62-.85-18,1.79-24.66,4.49-30.33S240.51,280.81,235.56,275.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "211.835px 302.107px"
    },
    id: "el7645yjpgrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw6d4bckj7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.56,275.92l-24.41-9.06c-6.62-2.18-12.29.78-17.09,10.28s-10.41,26.51-7.28,51.09c1.44,11,34.79,15.23,42.11-.62-.85-18,1.79-24.66,4.49-30.33S240.51,280.81,235.56,275.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "211.835px 302.107px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,299.11l5.12,7.15c6.93-3,13.47-9.48,13.47-9.48l4.12-5.24a7.33,7.33,0,0,1,2.58-2c3.51-1.67,5.26-1.74,7-.88a2.58,2.58,0,0,1-.06,4.71c-1.71.74-3.28,1.38-3.28,1.38a8,8,0,0,1-4.66,5.36c-7.49,14.2-16.48,22.48-22.1,21.49s-13.21-13.4-13.21-13.4Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "265.633px 304.898px"
    },
    id: "el8qlaff8phi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloojtb76a359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.17,311.54c.07-2.05-.76-4.69-1.8-5.28.28-.12.57-.26.85-.4A4.2,4.2,0,0,1,261.17,311.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "260.625px 308.7px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,274.65l1.43.46a19.24,19.24,0,0,1,9.86,7.19l12.27,17.25c-3.66,8.2-13,9.94-13,9.94l-12.12-15.43C223.53,284.12,229.19,275.68,232.14,274.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "241.444px 292.07px"
    },
    id: "elbjz6zysouo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloboyw136cdn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.14,274.65l1.43.46a19.24,19.24,0,0,1,9.86,7.19l12.27,17.25c-3.66,8.2-13,9.94-13,9.94l-12.12-15.43C223.53,284.12,229.19,275.68,232.14,274.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "241.444px 292.07px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.32,364.35,210.19,414c-.39,1.75-2.7,1.05-2.7-.21s4.36-51.49,4.36-51.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.405px 388.674px"
    },
    id: "elcuqgq0eer3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela69m4s4lzdb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.85,362.44l5.47,2-1,6.76a13.14,13.14,0,0,1-5.18-1C211.58,365.56,211.85,362.44,211.85,362.44Z",
    style: {
      opacity: 0.3,
      transformOrigin: "214.23px 366.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,351.34l5.84,38.4c.46,2.23-2.13,2.14-2.57,0s-7.24-34.52-7.24-34.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.602px 371.359px"
    },
    id: "elh7a13kz2gql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9j755gnowb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.55,359.39c-.53-2.54-.88-4.17-.88-4.17l4-3.88.74,4.87A12.12,12.12,0,0,1,245.55,359.39Z",
    style: {
      opacity: 0.3,
      transformOrigin: "247.04px 355.365px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.15,330.73c-4.36-14.88-8.82-28.11-27.51-36.34-6.59-2.91-10.11-1.87-11.77.69h0a14.1,14.1,0,0,1,4.25-4.77v0c2-1.53,5.27-1.77,10.6.58C192,297.2,198,306.42,201.94,317.05c1.22,3.28,2.25,6.7,3.28,10.2,3.76,12.83,8.3,29.57,17,34.14,3,1.58,14.88-4.58,23.07-11.12s9.92-9.82,10.37-12v4.39a7.1,7.1,0,0,1-1.32,4.13c-8.27,11.58-23.29,18.44-30.7,19.29C211.92,365.75,206.51,345.61,202.15,330.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "209.265px 327.611px"
    },
    id: "eld8h6ymdj8w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwtr2si9m3r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.15,330.73c-4.36-14.88-8.82-28.11-27.51-36.34-6.59-2.91-10.11-1.87-11.77.69h0a14.1,14.1,0,0,1,4.25-4.77v0c2-1.53,5.27-1.77,10.6.58C192,297.2,198,306.42,201.94,317.05c1.22,3.28,2.25,6.7,3.28,10.2,3.76,12.83,8.3,29.57,17,34.14,3,1.58,14.88-4.58,23.07-11.12s9.92-9.82,10.37-12v4.39a7.1,7.1,0,0,1-1.32,4.13c-8.27,11.58-23.29,18.44-30.7,19.29C211.92,365.75,206.51,345.61,202.15,330.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "209.265px 327.611px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,300.17a9.43,9.43,0,0,1,1.25-5.09c1.66-2.56,5.18-3.6,11.77-.69,18.69,8.23,23.15,21.46,27.51,36.34s9.77,35,21.49,35.32c-11.63,3.34-36.65-10-49-18.58a23.63,23.63,0,0,1-9-12.14C161,321,161.62,304.75,161.62,300.17Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "192.616px 329.605px"
    },
    id: "elhcc8rwkygbg",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTheDataAnimate);
export default __webpack_public_path__ + "static/media/all-the-data-animate.5b6d2d65a652e221422f2aa89ae6e22f.svg";
export { ForwardRef as ReactComponent };